import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useOrders } from "../../pages/DefaultPage/connect/Orders";
import { useLocations } from "../../States/Location/Location";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroller";
// import OneCard from "../ADUser/OneCard";
import TwoCard from "../ADUser/TwoCard";
import { baseUrl } from "../../baseurl";
import { ADS_MainCategoryCode } from "../../SharedData";
import { ADS_PropertyTypeCode } from "../../SharedData";
import { ADS_PropertyTradeTypeCode } from "../../SharedData";
import Loader from "../Loader/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import FormatPrice from "../FormatPrice/FormatPricw";
import ConvertPersianToEnglish from "../ConvertToEnglish/ConvertToEnglish";
import DatePicker, { Calendar } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Num2persian from "num2persian";
import { useAuth } from "../../pages/login/connect/Login";
import useLocationStore from "../store/locationStore";
import { useFilterStores } from "../store/filterItemsForNewFilter";
import { useSearchStore } from "../store/searchStore";

// used in every page that has filter,search and then shows ads(cards) based on user interaction
function NewFilter(props) {

    const { filterState, updateFilterState, resetFilterState, updateSelectedTradeType, updateSelectedPropertyType } = useFilterStores();
    const { setSearchValue, searchValue } = useSearchStore();
    const isInitialRender = useRef(true);
    const [isFilterPrice, setIsFilterPrice] = useState(false)
    // import stors and actions from zustand (start)
    const allMasterOrders = useOrders((state) => state.allMasterOrders);
    const storeItems = useOrders((state) => state.storeItems);
    const storePage = useOrders((state) => state.storePage);

    // const isSearch = useOrders((state) => state.isSearch);
    const { getDetailMasterByQueryByAllStrings, addStoreItem, setHasMoreStore, addItemsInStore, setApiData, clearStoreItems, clearStorePage } = useOrders((state) => state.actions);
    const { getUserInfoByToken } = useAuth((state) => state.actions);
    const userSubs = useAuth((state) => state.userSubs);
    const hasSubOrNot = useAuth((state) => state.hasSubOrNot);
    const citiess = useLocations((state) => state.cities)
    const loader = useOrders((state) => state.loader);
    const [checkLoadData, setCheckLoadData] = useState(false)
    const [hasMoreThanStoreItems, setHasMoreThanStoreItems] = useState(false)
    const [isButtonActive, setIsButtonActive] = useState(true)
    const [lastID, setLastID] = useState(true)
    const [addedByValue, setAddedByValue] = useState(null)
    const bottomBoundaryRef = useRef(null);
    const [boughtDistrictsID, setBoughtDistrictsID] = useState([])
    // const [provinceCode, setProvinceCode] = useState(provinceCode);
    // const [cityCode, setCityCode] = useState(cityCode);
    const { provinceCode, clearLocations } = useLocationStore();
    // import stors and actions from zustand (end)
    const cityCode = useLocationStore((state) => state.cityCode)
    const iscommunalPage = window.location.pathname.includes('/communal');
    const isPersonalPage = window.location.pathname.includes('/personal');
    const isGenericPage = window.location.pathname.includes('/generic');
    const isProfilePage = window.location.pathname.includes('/Profile');
    const state = localStorage.getItem("location-storage")
    const parsedState = JSON.parse(state)
    const isInTehran = parsedState?.state?.provinceCode === 2;

    // if the state were tehran don't show رهن و اجاره کوتاه مدت"
    const filteredADS_PropertyTradeTypeCode = isInTehran ? ADS_PropertyTradeTypeCode.filter(sub => sub.id !== 6) : ADS_PropertyTradeTypeCode;
    const isInTehranCity = parsedState?.state?.cityCode === 3;
    console.log({ isInTehranCity });
    // console.log(viewedAdIds, "viewedAdIds");


    useEffect(() => {
        const isPersonalPage = window.location.pathname.includes('/personal');
        const isGenericPage = window.location.pathname.includes('/generic');

        if (isPersonalPage) {
            setAddedByValue(1);
        } else if (isGenericPage) {
            setAddedByValue(2);
        } else {
            setAddedByValue(0);
        }
    }, [window.location.pathname]);

    useEffect(() => {
        if (bottomBoundaryRef.current) {
            setHasMoreThanStoreItems(true)
        }
    }, [bottomBoundaryRef.current])

    useEffect(() => {
        getUserInfoByToken(0);
    }, [getUserInfoByToken]);
    useEffect(() => {
        // React to changes in `userSubs` after it is fetched
        if (hasSubOrNot && userSubs) {
            const subsDistrictID = userSubs.map(userSub =>
                userSub?.map(item => item?.bseCityStateId)
            );
            const singleArray = subsDistrictID?.flat()
            const noDuplicate = new Set(singleArray)
            const arrayAgain = [...noDuplicate]
            setBoughtDistrictsID(arrayAgain)
        }
    }, [userSubs, hasSubOrNot]);


    // useEffect(() => {
    //     // setLastID(false);
    //     // filter();
    //     // clearStorePage();
    //     // setPage(0);

    //     console.log("this happened");

    // }, [props.isSearch])
    // useEffect(() => {
    //     if (props.isSearch) {
    //       // ✅ Do something when search is triggered
    //       console.log('Search triggered with:', searchValue);

    //       // Example: call API or filter logic here

    //       // Optionally reset isSearch to false so it doesn’t keep triggering
    //       props.setIsSearch(false);
    //     }
    //   }, [props.isSearch]);
    useEffect(() => {
        if (isInitialRender.current) {
            // Skip logic on the initial render
            isInitialRender.current = false; // Update the flag after the first render
            return;
        }

        // Add your logic here based on the changes
        // window.location.reload()
        setPage(0); // Reset page
        setItems([]); // Clear current items
        setHasMore(true); // Allow InfiniteScroll to proceed
        filter()
    }, [cityCode, localStorage.getItem("pelakToken")]);

    const params = new URLSearchParams(window.location?.search)
    const districtIDs = params?.get('districts')?.split(',')?.map(Number)


    // states for get values from user (start)
    const [parking, setParking] = useState(null)
    const [basement, setbasement] = useState(filterState.basement)
    const [elevator, setElevator] = useState(filterState.elevator)
    const [isShowFilters, setIsShowFilters] = useState(false)
    const [moveToSelectArea, setMoveToSelectArea] = useState(false)
    const [isShowChoseCategoryPage, setIsShowChoseCategoryPage] = useState(false)
    const [selectedCategoryItem, setSelectedCategoryItem] = useState(0)
    const [isShowChoseMElkTypePage, setIsShowChoseMElkTypePage] = useState(false)
    const [selectedMelkTypeItem, setSelectedMelkTypeItem] = useState(filterState.selectedPropertyType)
    const [isShowChoseMoamelePage, setIsShowChoseMoamelePage] = useState(false)
    const [selectedMelkMoameleItem, setSelectedMelkMoameleItem] = useState(filterState.selectedTradeType)
    const [isShowDeposit, setIsDeposit] = useState(false)
    const [isShowRentPerMonth, setIsShowRentPerMonth] = useState(false)
    const [isShowPrice, setIsShowPrice] = useState(false)
    const [isRoomNumber, setIsRoomNumber] = useState(false)
    const [isShowOptions, setIsShowOptions] = useState(false)
    const [isShowMetrage, setIsShowMetrage] = useState(false)
    const [isShowLife, setIsShowLife] = useState(false)
    const [selectedAreas, setSelectedAreas] = useState([])
    const [adsAdvertiseTypeCode, setAdsAdvertiseTypeCode] = useState(0)
    const [type, setType] = useState(false)
    const [priceFrom, setPriceFrom] = useState(filterState?.priceFrom)
    const [numberOfRoomsFrom, setNumberOfRoomsFrom] = useState(filterState?.numberOfRoomsFrom)
    const [numberOfRoomsTo, setNumberOfRoomsTo] = useState(filterState?.numberOfRoomsTo)
    const [priceTo, setPriceTo] = useState(filterState?.priceTo)
    const [meterageFrom, setMeterageFrom] = useState(filterState?.meterageFrom)
    const [meterageTo, setMeterageTo] = useState(filterState?.meterageTo)
    const [buldingLifeFrom, setBuldingLifeFrom] = useState()
    const [buldingLifeTo, setBuldingLifeTo] = useState()
    const [depositFrom, setDepositFrom] = useState()
    const [depositTo, setDepositTo] = useState()
    const [rentFrom, setRentFrom] = useState()
    const [rentTo, setRentTo] = useState()
    const [noeAgahiDahande, setNoAgahiDahande] = useState(0)
    const [isShowTypeAdsDahande, setIsShowAdsDahande] = useState(false)
    const [cityState, setCityState] = useState([citiess])
    const [searchInCitiesValue, setSearchInCitiesValue] = useState("")
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(storePage);
    const [hasMore, setHasMore] = useState(true)
    const [selectedAreasIDs, setSelectedAreasIDs] = useState([filterState?.selectedAreasIDs])
    const navigate = useNavigate();
    const location = useLocation();
    const [propertyCodeName, setPropertyCodeName] = useState("")
    const [districtIdsFromURL, setDistrictIdsFromURL] = useState([])
    // states for get values from user (end)

    const pathSegments = location.pathname.split('/');

    // this states add to api (start)
    const [dailyPriceFrom, setDailyPriceFrom] = useState()
    const [dailyPriceTo, setDailyPriceTo] = useState()
    const [isShowDailyPrice, setIsShowDailyPrice] = useState()
    const [pricePerMeterFrom, setPricePerMeterFrom] = useState()
    const [pricePerMeterTo, setPricePerMeterTo] = useState()
    const [isShowPricePerMeter, setIsShowPricePerMeter] = useState()
    const [priceTotalFrom, setPriceTotalFrom] = useState()
    const [priceTotalTo, setPriceTotalTo] = useState()
    const [isShowPriceTotal, setIsShowPriceTotal] = useState()
    const [isFetchData, setIsFetchData] = useState(false)
    const [noResult, setNoResult] = useState(false)
    const [flag, setFlag] = useState(false)
    const [isCommunal, setIsCommunal] = useState(filterState?.isCommunal)
    const [isGeneric, setIsGeneric] = useState(filterState?.isGeneric)
    const [isPersonal, setIsPersonal] = useState(filterState?.isPersonal)
    const [selectedAdTypes, setSelectedAdTypes] = useState([])
    // this states add to api (end)


    const [selectedDate, setSelectedDate] = useState(null);
    const [isCalendarOpen, setCalendarOpen] = useState(false);
    const [isNoeAgahaiVisible, SetIsNoeAgahaiVisible] = useState(false);

    const toggleCalendar = () => setCalendarOpen(!isCalendarOpen);
    const datePickerRef = useRef();



    const prevPath = useRef(null);

    useEffect(() => {
        // Run on every path change
        if (prevPath.current === "/AdsOnMap" && location.pathname === "/") {
            resetFilterState()
        }

        // update prevPath for next render
        prevPath.current = location.pathname;
    }, [location.pathname]);

    useEffect(() => {
        if (isCalendarOpen && datePickerRef.current) {
            datePickerRef.current.openCalendar();
        }
    }, [isCalendarOpen]);
    const x = window.location.pathname

    const registerStatus = {
        23: "  تایید شده ",
        24: " در انتظار تایید ",
        25: "  رد شده",
        26: " در انتظار پرداخت",
    }
    const transactions = [
        { id: 0, title: "همه", href: "", engTitle: "all" },
        { id: 1, title: "فروش", href: "", engTitle: "buyAndSell" },
        { id: 2, title: "رهن و اجاره", href: "", engTitle: "Rent" },
        { id: 3, title: "معاوضه", href: "", engTitle: "exchange" },
        { id: 4, title: "مشارکت در ساخت", href: "", engTitle: "Participation" },
        { id: 5, title: "پیش فروش", href: "", engTitle: "PreSale" },
        { id: 6, title: "رهن و اجاره کوتاه مدت", href: "", engTitle: "ShortRent" },
        { id: 7, title: "متقاضی خرید", href: "", engTitle: "Purchaser" },
        { id: 8, title: "متقاضی اجاره", href: "", engTitle: "Renter" },
    ];
    const PropertyTypes = [
        { id: 1, title: "آپارتمان مسکونی", href: "", engTitle: "Residential" },
        { id: 2, title: "آپارتمان اداری", href: "", engTitle: "Office" },
        { id: 3, title: "خانه و ویلا", href: "", engTitle: "Villa" },
        { id: 4, title: "زمین و کلنگی", href: "", engTitle: "Land" },
        { id: 5, title: "مستغلات", href: "", engTitle: "RealEstate" },
        { id: 6, title: "مغازه", href: "", engTitle: "Shop" },
        { id: 7, title: "صنعتی و کشاورزی", href: "", engTitle: "Industrial" },
    ];
    const adTypes = [
        { id: 0, title: "همه آگهی ها", desc: "همه آگهی ها شامل آگهی های تعاون، شخصی و عمومی میشود" },
        { id: 1, title: "  آگهی تعاون", desc: " آگــهی‌ تعاون، آگهی هایی هستند که مشاورین املاک جهت همکاری با سایر مشاورین، در پلاک من ثبت کرده اند" },
        { id: 3, title: " پلاک من", desc: " آگهی هایی هستند که که کارشناسان پلاک من به طور شخصی به دست آورده، توسط مالکین و سازندگان ثبت شده و یا از پلتفرم هایی مانند ویو، دیوار و شیپور جمع آوری شده اند" },
        // { id: 2, title: "  آگهی شخصی", desc: "  آگــهی‌ شخصی، آگهی هایی هستند که کارشناسان پلاک من به طور شخصی به دست آورده و ثبت نموده اند " },
        // { id: 3, title: "آگهی عمومی  ", desc: " آگــهی‌ عمومی، آگهی هایی هستند که از پلتفرم هایی مانند ویو، دیوار و شیپور جمع آوری شده اند" },
    ]
    const firstSegment = pathSegments[1];
    const secondSegment = pathSegments[2];
    const matchTransactionID = transactions?.find((trans) => trans?.engTitle === firstSegment)?.id
    const matchPropertyTypesID = PropertyTypes?.find((property) => property?.engTitle === secondSegment)?.id


    const fetchData = async (__page) => {
        if (checkLoadData) return;
        //  setCheckLoadData(false)


        const yu = selectedAreas?.map(item => item?.id
        )
        console.log(selectedAreasIDs[0], "2222222 selectedAreasIDs[0] ");
        console.log(selectedAreasIDs, " selectedAreasIDs fetchhhh true ");
        console.log({ yu });
        (isFetchData) &&
            await axios.post(`${baseUrl}/Advertise/GetDetailMasterByQuery`, {
                "lastId": items[items.length - 1]?.id,
                "page": page,
                // "adsMainCategoryCode": props.isFilterWithPropertyCode ? Number(props.isFilterWithPropertyCode) : Number(selectedCategoryItem !== 0 ? selectedCategoryItem.id : 0),
                "adsMainCategoryCode": isCommunal ? 8 : null,
                "userCode": props.userCode ? props.userCode : 0,
                "adsAdvertiseTypeCode": adsAdvertiseTypeCode ? Number(adsAdvertiseTypeCode) : 0,
                "adsPrptyTradeTypeCode": [
                    // selectedMelkMoameleItem ? Number(selectedMelkMoameleItem.id) : 0

                    (selectedMelkMoameleItem && selectedMelkMoameleItem.id) ? Number(selectedMelkMoameleItem.id) : matchTransactionID ? matchTransactionID : 0
                ],
                "adsPrptyTypeCode": [
                    // selectedMelkTypeItem ? Number(selectedMelkTypeItem.id) : 0
                    (selectedMelkTypeItem && selectedMelkTypeItem.id) ? Number(selectedMelkTypeItem.id) : matchPropertyTypesID ? matchPropertyTypesID : 0
                ],
                "userTypeCode": [
                    noeAgahiDahande ? Number(noeAgahiDahande) : 0
                ],
                "countryCode": 0,
                "stateCode": provinceCode ?? 0,
                "cityCode": cityCode ?? 0,
                // "areaCode": !selectedAreasIDs[0] ? districtIDs : selectedAreasIDs[0],
                "areaCode": !selectedAreasIDs[selectedAreasIDs?.length - 1].length ? districtIDs : selectedAreasIDs[selectedAreasIDs?.length - 1],
                "priceFrom": priceFrom ? priceFrom : 0,
                "priceTo": priceTo ? priceTo : 0,
                "depositFrom": depositFrom ? depositFrom : 0,
                "depositTo": depositTo ? depositTo : 0,
                "rentFrom": rentFrom ? rentFrom : 0,
                "rentTo": rentTo ? rentTo : 0,
                "meterageFrom": meterageFrom ? meterageFrom : 0,
                "meterageTo": meterageTo ? meterageTo : 0,
                "buldingLifeFrom": buldingLifeFrom ? buldingLifeFrom : 0,
                "buldingLifeTo": buldingLifeTo ? buldingLifeTo : 0,
                "adsDateTimeFrom": selectedDate ? selectedDate[0]?.toDate()?.toISOString() : null,
                "adsDateTimeTo": selectedDate ? selectedDate[1]?.toDate()?.toISOString() : null,
                "parking": parking,
                "basement": basement,
                "elevator": elevator,
                "addedBy": isPersonal ? 1 : isGeneric ? 2 : 0,
                "searchQuery": props?.searchValue ? props?.searchValue : null,
                "numberOfRoomsFrom": numberOfRoomsFrom ? numberOfRoomsFrom : 0,
                "numberOfRoomsTo": numberOfRoomsTo ? numberOfRoomsTo : 0,
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then(async (res) => {

                    if (res.data.length) {
                        setItems([...items, ...res.data]);
                        setPage(page + 20);
                    }
                    else {
                        setHasMore(false)
                        // setNoResult(true)
                    }
                })
    };
    if (selectedAreas && selectedAreas.length > 0) {
        const url = new URL(window.location);
        url.searchParams.delete('districts'); // Remove the 'districts' query parameter
        window.history.replaceState(null, '', url); // Update the URL without reloading
    }
    useEffect(() => {
        // Call filter only when lastID has been set to false
        if (lastID === false) {
            filter();
        }
    }, [lastID]);

    const filter = async (isCommunalValue = isCommunal, isPersonalValue = isPersonal, isGenericValue = isGeneric) => {


        setItems([])
        setCheckLoadData(true)
        clearStoreItems()

        const yu = selectedAreas?.map(item => item?.id
        )

        selectedAreasIDs.push(selectedAreas.map(area => area.id))

        const lastSelectedArea = selectedAreasIDs[selectedAreasIDs?.length - 1] || districtIDs;
        updateFilterState({
            selectedAreasIDs: lastSelectedArea ? lastSelectedArea : [],
            priceFrom: priceFrom,
            priceTo: priceTo,
            meterageFrom: meterageFrom,
            meterageTo: meterageTo,
            isCommunal: isCommunalValue,
            isPersonal: isPersonalValue,
            isGeneric: isGenericValue,
            numberOfRoomsFrom: numberOfRoomsFrom,
            numberOfRoomsTo: numberOfRoomsTo,

        });
        updateSelectedTradeType(selectedMelkMoameleItem)
        updateSelectedPropertyType(selectedMelkTypeItem)
        await axios.post(`${baseUrl}/Advertise/GetDetailMasterByQuery`, {
            "lastId": lastID ? items[items.length - 1]?.id : 0,
            "page": 0,
            // "adsMainCategoryCode": props.isFilterWithPropertyCode ? Number(props.isFilterWithPropertyCode) : Number(selectedCategoryItem !== 0 ? selectedCategoryItem.id : 0),
            "adsMainCategoryCode": isCommunalValue ? 8 : null,
            "userCode": props.userCode ? props.userCode : 0,
            "adsAdvertiseTypeCode": adsAdvertiseTypeCode ? Number(adsAdvertiseTypeCode) : 0,
            "adsPrptyTradeTypeCode": [
                // selectedMelkMoameleItem ? Number(selectedMelkMoameleItem.id) : 0
                (selectedMelkMoameleItem && selectedMelkMoameleItem.id) ? Number(selectedMelkMoameleItem.id) : matchTransactionID ? matchTransactionID : 0
            ],
            "adsPrptyTypeCode": [
                // selectedMelkTypeItem ? Number(selectedMelkTypeItem.id) : 0
                (selectedMelkTypeItem && selectedMelkTypeItem.id) ? Number(selectedMelkTypeItem.id) : matchPropertyTypesID ? matchPropertyTypesID : 0
            ],
            "userTypeCode": [
                noeAgahiDahande ? Number(noeAgahiDahande) : 0
            ],
            "countryCode": 0,
            "stateCode": provinceCode ?? 0,
            "cityCode": cityCode ?? 0,
            "areaCode": !selectedAreasIDs[selectedAreasIDs?.length - 1].length ? districtIDs : selectedAreasIDs[selectedAreasIDs?.length - 1],
            // "areaCode": !yu ? districtIDs : yu,
            // "areaCode": !yu ? districtIDs : yu,
            "priceFrom": priceFrom ? priceFrom : 0,
            "priceTo": priceTo ? priceTo : 0,
            "depositFrom": depositFrom ? depositFrom : 0,
            "depositTo": depositTo ? depositTo : 0,
            "rentFrom": rentFrom ? rentFrom : 0,
            "rentTo": rentTo ? rentTo : 0,
            "meterageFrom": meterageFrom ? meterageFrom : 0,
            "meterageTo": meterageTo ? meterageTo : 0,
            "buldingLifeFrom": buldingLifeFrom ? buldingLifeFrom : 0,
            "buldingLifeTo": buldingLifeTo ? buldingLifeTo : 0,
            "adsDateTimeFrom": selectedDate ? selectedDate[0]?.toDate()?.toISOString() : null,
            "adsDateTimeTo": selectedDate ? selectedDate[1]?.toDate()?.toISOString() : null,
            "parking": parking,
            "basement": basement,
            "elevator": elevator,
            "addedBy": isPersonalValue ? 1 : isGenericValue ? 2 : 0,
            "numberOfRoomsFrom": numberOfRoomsFrom ? numberOfRoomsFrom : 0,
            "numberOfRoomsTo": numberOfRoomsTo ? numberOfRoomsTo : 0,
            "searchQuery": searchValue ? searchValue : null,
            "onMap": props.isInOnMap ? true : null,
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
            },
        })
            .then((res) => {

                setCheckLoadData(false)
                if (res.data.length) {

                    setNoResult(false)

                    setItems(res.data);
                    setPage(page + 20)
                    setApiData(res.data)/*  for ads ON map */
                } else {
                    setHasMore(false)
                    setNoResult(true)
                }
            })
        setIsShowChoseCategoryPage(false)
        setIsShowFilters(false)
        setIsShowChoseMElkTypePage(false)
        setIsShowChoseMoamelePage(false)
        setMoveToSelectArea(false)

        setIsButtonActive(true)
    }
    const toggleSelect = (adType) => {

        setSelectedAdTypes(adType.id === selectedAdTypes?.id ? null : adType);
        if (adType?.id === 1) {
            setIsCommunal(true)
            setIsGeneric(false)
            setIsPersonal(false)
            updateFilterState({ isCommunal: true })
        } else if (adType?.id === 3) {
            setIsGeneric(true)
            setIsPersonal(false)
            setIsCommunal(false)
            updateFilterState({ isCommunal: false })
        }
        else if (adType?.id === 2) {
            setIsPersonal(true)
            setIsGeneric(false)
            setIsCommunal(false)
            updateFilterState({ isCommunal: false })
        }
        else if (adType?.id === 0) {
            setIsGeneric(false)
            setIsPersonal(false)
            setIsCommunal(false)
            updateFilterState({ isCommunal: false })
        }
    }
    useEffect(() => {
        switch (props.isFilterWithPropertyCode) {
            case "2":
                setPropertyCodeName("آهن و فلزات")
                break;
            case "3":
                setPropertyCodeName("مصالح ساختمانی")
                break;
            case "4":
                setPropertyCodeName("ماشین آلات و ابزار")
                break;
            case "5":
                setPropertyCodeName("تاسیسات و تجهیزات")
                break;
            case "6":
                setPropertyCodeName("نیروی کار ساختمانی")
                break;
            case "7":
                setPropertyCodeName("معماری و پیمانکاری")
                break;

            default:
        }
    }, [selectedCategoryItem, selectedMelkTypeItem, selectedMelkMoameleItem, selectedAreas, moveToSelectArea, adsAdvertiseTypeCode, noeAgahiDahande, selectedAreasIDs])

    // useEffect(() => {
    //     if (props.Profile) {
    //    
    //         props?.setIsSearch(false)       
    //              axios.post(`${baseUrl}/Advertise/GetDetailMasterByQuery`, {
    //             "lastId": items[items.length - 1]?.id,
    //             "page": 0,
    //             // "adsMainCategoryCode": props.isFilterWithPropertyCode ? Number(props.isFilterWithPropertyCode) : Number(selectedCategoryItem !== 0 ? selectedCategoryItem.id : 0),
    //             "adsMainCategoryCode": iscommunalPage ? 8 : null,
    //             "userCode": props.userCode ? props.userCode : 0,
    //             "adsAdvertiseTypeCode": adsAdvertiseTypeCode ? Number(adsAdvertiseTypeCode) : 0,
    //             "adsPrptyTradeTypeCode": [
    //                 selectedMelkMoameleItem ? Number(selectedMelkMoameleItem.id) : 0
    //             ],
    //             "adsPrptyTypeCode": [
    //                 selectedMelkTypeItem ? Number(selectedMelkTypeItem.id) : 0
    //             ],
    //             "userTypeCode": [
    //                 noeAgahiDahande ? Number(noeAgahiDahande) : 0
    //             ],
    //             "countryCode": 0,
    //             "stateCode": 0,
    //             "cityCode": 0,
    //             "areaCode": !selectedAreasIDs[0] ? districtIDs : selectedAreasIDs[0],
    //             "priceFrom": priceFrom ? priceFrom : 0,
    //             "priceTo": priceTo ? priceTo : 0,
    //             "depositFrom": depositFrom ? depositFrom : 0,
    //             "depositTo": depositTo ? depositTo : 0,
    //             "rentFrom": rentFrom ? rentFrom : 0,
    //             "rentTo": rentTo ? rentTo : 0,
    //             "meterageFrom": meterageFrom ? meterageFrom : 0,
    //             "meterageTo": meterageTo ? meterageTo : 0,
    //             "buldingLifeFrom": buldingLifeFrom ? buldingLifeFrom : 0,
    //             "buldingLifeTo": buldingLifeTo ? buldingLifeTo : 0,
    //             "adsDateTimeFrom": selectedDate ? selectedDate[0]?.toDate()?.toISOString() : null,
    //             "adsDateTimeTo": selectedDate ? selectedDate[1]?.toDate()?.toISOString() : null,
    //             "parking": parking,
    //             "basement": basement,
    //             "elevator": elevator
    //         }, {
    //             headers: {
    //                 Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
    //             },
    //         })
    //             .then((res) => {
    //                 if (res.data.length < 20) {
    //                     setItems(res.data);
    //                     setHasMore(false)
    //                     setIsFetchData(true)
    //                 } else {
    //                     setPage(page + 20);
    //                     setItems(res.data);
    //                     setIsFetchData(true)
    //                 }
    //             })
    //     }
    // }, [props])

    // useEffect(() => {

    //     // setCityState(citiess); // moved to new useEffect
    //     if (!checkLoadData) {


    //         // setCheckLoadData(true)
    //         !isSearch &&

    //             axios.post(`${baseUrl}/Advertise/GetDetailMasterByQuery`, {
    //                 "lastId": items[items.length - 1]?.id,
    //                 "page": 0,
    //                 // "adsMainCategoryCode": props.isFilterWithPropertyCode ? Number(props.isFilterWithPropertyCode) : Number(selectedCategoryItem !== 0 ? selectedCategoryItem.id : 0),
    //                 "adsMainCategoryCode": iscommunalPage ? 8 : null,
    //                 "userCode": props.userCode ? props.userCode : 0,
    //                 "adsAdvertiseTypeCode": adsAdvertiseTypeCode ? Number(adsAdvertiseTypeCode) : 0,
    //                 "adsPrptyTradeTypeCode": [
    //                     // selectedMelkMoameleItem ? Number(selectedMelkMoameleItem.id) : 0
    //                     selectedMelkMoameleItem ? Number(selectedMelkMoameleItem.id) : matchTransactionID ? matchTransactionID : 0
    //                 ],
    //                 "adsPrptyTypeCode": [
    //                     // selectedMelkTypeItem ? Number(selectedMelkTypeItem.id) : 0
    //                     selectedMelkTypeItem ? Number(selectedMelkTypeItem.id) : matchPropertyTypesID ? matchPropertyTypesID : 0
    //                 ],
    //                 "userTypeCode": [
    //                     noeAgahiDahande ? Number(noeAgahiDahande) : 0
    //                 ],
    //                 "countryCode": 0,
    //                 "stateCode": 0,
    //                 "cityCode": 0,
    //                 // "areaCode": !selectedAreasIDs[0] ? districtIDs : selectedAreasIDs[0],
    //                 "areaCode": !selectedAreasIDs[selectedAreasIDs?.length - 1] ? districtIDs : selectedAreasIDs[selectedAreasIDs?.length - 1],
    //                 "priceFrom": priceFrom ? priceFrom : 0,
    //                 "priceTo": priceTo ? priceTo : 0,
    //                 "depositFrom": depositFrom ? depositFrom : 0,
    //                 "depositTo": depositTo ? depositTo : 0,
    //                 "rentFrom": rentFrom ? rentFrom : 0,
    //                 "rentTo": rentTo ? rentTo : 0,
    //                 "meterageFrom": meterageFrom ? meterageFrom : 0,
    //                 "meterageTo": meterageTo ? meterageTo : 0,
    //                 "buldingLifeFrom": buldingLifeFrom ? buldingLifeFrom : 0,
    //                 "buldingLifeTo": buldingLifeTo ? buldingLifeTo : 0,
    //                 "adsDateTimeFrom": selectedDate ? selectedDate[0]?.toDate()?.toISOString() : null,
    //                 "adsDateTimeTo": selectedDate ? selectedDate[1]?.toDate()?.toISOString() : null,
    //                 "parking": parking,
    //                 "basement": true,
    //                 "elevator": elevator,
    //                 // "addedBy": isPersonalPage ? 1 : isGenericPage ? 2 : 0
    //                 "addedBy": isPersonalPage ? 1 : isGenericPage ? 2 : 0,
    //                 "onMap": props.isInOnMap ? true : null
    //             }, {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
    //                 },
    //             })
    //                 .then((res) => {
    //                     if (!res.data.length) {
    //                         setNoResult(true)
    //                     }
    //                     if (res.data.length < 20) {
    //                         console.log(setApiData(res.data), " setApiData(res.data)", res.data);

    //                         setApiData(res.data)
    //                         setItems(res.data);
    //                         setHasMore(false)
    //                         setIsFetchData(true)
    //                     } else {
    //                         console.log("sssssssssjf");
    //                         setApiData(res.data)
    //                         setPage(page + 20);
    //                         setItems(res.data);
    //                         setIsFetchData(true)
    //                     }
    //                 })
    //     }
    // }, [
    //     selectedCategoryItem,
    //     selectedMelkTypeItem, selectedMelkMoameleItem, props.isFilterWithPropertyCode,
    //     parking && parking,
    //     basement && basement,
    //     elevator && elevator,
    //     isFilterPrice && priceFrom, isFilterPrice && priceTo,
    //     selectedAreas, adsAdvertiseTypeCode, noeAgahiDahande, selectedAreasIDs, window.location.pathname, x, flag])
    // useEffect(() => {
    //     updateFilterState({
    //         parking,
    //         basement,
    //         elevator,
    //         priceFrom,
    //         priceTo,
    //         selectedAreas,
    //     });
    // }, [parking, basement, elevator, priceFrom, priceTo, selectedAreas]);
    // console.log(filterState, "filterState in NewFilter");
    console.log(searchValue, "searchValue in NewFilter");
    console.log(props.isSearch, "props.isSearch in NewFilter");


    useEffect(() => {

        // setCityState(citiess); // moved to new useEffect
        if (!checkLoadData) {


            // setCheckLoadData(true)


            axios.post(`${baseUrl}/Advertise/GetDetailMasterByQuery`, {
                "lastId": items[items.length - 1]?.id,
                "page": page,
                // "adsMainCategoryCode": props.isFilterWithPropertyCode ? Number(props.isFilterWithPropertyCode) : Number(selectedCategoryItem !== 0 ? selectedCategoryItem.id : 0),
                "adsMainCategoryCode": iscommunalPage ? 8 : null,
                "userCode": props.userCode ? props.userCode : 0,
                "adsAdvertiseTypeCode": adsAdvertiseTypeCode ? Number(adsAdvertiseTypeCode) : 0,
                "adsPrptyTradeTypeCode": [
                    // selectedMelkMoameleItem ? Number(selectedMelkMoameleItem.id) : 0
                    (selectedMelkMoameleItem && selectedMelkMoameleItem.id) ? Number(selectedMelkMoameleItem.id) : matchTransactionID ? matchTransactionID : 0
                ],
                "adsPrptyTypeCode": [
                    // selectedMelkTypeItem ? Number(selectedMelkTypeItem.id) : 0
                    (selectedMelkTypeItem && selectedMelkTypeItem.id) ? Number(selectedMelkTypeItem.id) : matchPropertyTypesID ? matchPropertyTypesID : 0
                ],
                "userTypeCode": [
                    noeAgahiDahande ? Number(noeAgahiDahande) : 0
                ],
                "countryCode": 0,
                "stateCode": provinceCode ?? 0,
                "cityCode": cityCode ?? 0,
                // "areaCode": !selectedAreasIDs[0] ? districtIDs : selectedAreasIDs[0],
                "areaCode": !selectedAreasIDs[selectedAreasIDs?.length - 1].length ? districtIDs : selectedAreasIDs[selectedAreasIDs?.length - 1],
                "priceFrom": priceFrom ? priceFrom : 0,
                "priceTo": priceTo ? priceTo : 0,
                "depositFrom": depositFrom ? depositFrom : 0,
                "depositTo": depositTo ? depositTo : 0,
                "rentFrom": rentFrom ? rentFrom : 0,
                "rentTo": rentTo ? rentTo : 0,
                "meterageFrom": meterageFrom ? meterageFrom : 0,
                "meterageTo": meterageTo ? meterageTo : 0,
                "buldingLifeFrom": buldingLifeFrom ? buldingLifeFrom : 0,
                "buldingLifeTo": buldingLifeTo ? buldingLifeTo : 0,
                "adsDateTimeFrom": selectedDate ? selectedDate[0]?.toDate()?.toISOString() : null,
                "adsDateTimeTo": selectedDate ? selectedDate[1]?.toDate()?.toISOString() : null,
                "parking": parking,
                "basement": basement,
                "elevator": elevator,
                // "addedBy": isPersonalPage ? 1 : isGenericPage ? 2 : 0
                "addedBy": isPersonal ? 1 : isGeneric ? 2 : 0,
                "onMap": props.isInOnMap ? true : null,
                "searchQuery": props?.searchValue ? props?.searchValue : null,
                "numberOfRoomsFrom": numberOfRoomsFrom ? numberOfRoomsFrom : 0,
                "numberOfRoomsTo": numberOfRoomsTo ? numberOfRoomsTo : 0,
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    if (!res.data.length) {
                        setNoResult(true)
                    }
                    if (res.data.length < 20) {


                        setApiData(res.data)
                        setItems(res.data);
                        setHasMore(false)
                        setIsFetchData(true)
                    } else {

                        setApiData(res.data)
                        setPage(page + 20);
                        setItems(res.data);
                        setIsFetchData(true)
                    }
                })
        }
    }, [
        // selectedCategoryItem,
        // selectedMelkTypeItem,
        //  selectedMelkMoameleItem,
        // provinceCode,
        // cityCode,
        props.isFilterWithPropertyCode,
        // props?.isSearch
        // parking && parking,
        // basement && basement,
        // elevator && elevator,
        // isFilterPrice && priceFrom, isFilterPrice && priceTo,
        // selectedAreas,
        //  adsAdvertiseTypeCode,
        //   noeAgahiDahande, 
        //    selectedAreasIDs
        , x,
        // flag
    ])
    // , moveToSelectArea REMOVED

    useEffect(() => {
        setCityState(citiess);
    }, [moveToSelectArea])

    // useEffect(() => {
    //     if (selectedAreas) {


    //         navigate(window.location.pathname, { replace: true });
    //     }
    // }, [])



    const clearFilters = () => {
        getDetailMasterByQueryByAllStrings(
                /*"page":*/ page,
            /*"adsMainCategoryCode":*/ Number(selectedCategoryItem !== 0 ? selectedCategoryItem.id : 0),
            /*"userCode":*/ props.userCode ? props.userCode : 0,
            /*"adsAdvertiseTypeCode": */  0,
            /*"adsPrptyTradeTypeCode": */[
                0
            ],
            /*"adsPrptyTypeCode":  */[
                0
            ],
            // "userTypeCode":
            [
                0
            ],
            /* "countryCode":*/ 0,
            /*"stateCode": */   provinceCode ?? 0,
            /*"cityCode": */     cityCode ?? 0,
            /*"areaCode": */[
                0
            ],
            /*"priceFrom" */   0,
            /*"priceTo" */ 0,
             /*"depositFrom" */  0,
            /*"depositTo" */  0,
            /*"rentFrom" */   0,
            /*"rentTo" */   0,
            /*"meterageFrom" */   0,
            /*"meterageTo" */   0,
            /*"buldingLifeFrom" */   0,
            /*"buldingLifeTo" */   0,
            /*"adsDateTimeFrom" */  null,
            /*"adsDateTimeTo" */  null,
            /*"parking" */  parking,
            /*"basement" */  basement,
            /*"elevator" */  elevator
        )
        setIsShowChoseCategoryPage(false)
        setIsShowFilters(false)
        setIsShowChoseMElkTypePage(false)
        setIsShowChoseMoamelePage(false)
        setMoveToSelectArea(false)
        setSelectedCategoryItem(0)
        setSelectedMelkMoameleItem(0)
        setSelectedMelkTypeItem(0)
        setPriceFrom("")
        setPriceTo("")
        setSelectedAreas([])
        // setSelectedAreasName([])
        setNoAgahiDahande("")
        setNumberOfRoomsFrom("")
        setNumberOfRoomsTo("")
        resetFilterState()
    }

    // select areas (find Duplicate == remove area from arry) ||  (find Duplicate != add area to arry)
    function toggleItem(item) {
        let findDuplicateIndex = selectedAreas.find(area => area.id === item.id);
        if (findDuplicateIndex) {

            setSelectedAreas(selectedAreas.filter(area => area.id != item.id));
        } else {


            selectedAreas.push(item);
        }
    }

    // search in areas 
    const searchInCitiesHandler = (e) => {
        setSearchInCitiesValue(e.target.value)
        setCityState(citiess.filter(item => item.locName.includes(e.target.value)));
    }



    // clear filters 
    const showAllAdss = async (__page) => {
        console.log("show all ads called");

        axios.post(`${baseUrl}/Advertise/GetDetailMasterByQuery`, {
            "lastId": items[items.length - 1]?.id,
            "page": page,
            // "adsMainCategoryCode": props.isFilterWithPropertyCode ? Number(props.isFilterWithPropertyCode) : Number(selectedCategoryItem !== 0 ? selectedCategoryItem.id : 0),
            "adsMainCategoryCode": iscommunalPage ? 8 : null,
            "userCode": props.userCode ? props.userCode : 0,
            "adsAdvertiseTypeCode": adsAdvertiseTypeCode ? Number(adsAdvertiseTypeCode) : 0,
            "adsPrptyTradeTypeCode": [
                // selectedMelkMoameleItem ? Number(selectedMelkMoameleItem.id) : 0
                (selectedMelkMoameleItem && selectedMelkMoameleItem.id) ? Number(selectedMelkMoameleItem.id) : matchTransactionID ? matchTransactionID : 0
            ],
            "adsPrptyTypeCode": [
                // selectedMelkTypeItem ? Number(selectedMelkTypeItem.id) : 0
                (selectedMelkTypeItem && selectedMelkTypeItem.id) ? Number(selectedMelkTypeItem.id) : matchPropertyTypesID ? matchPropertyTypesID : 0
            ],
            "userTypeCode": [
                noeAgahiDahande ? Number(noeAgahiDahande) : 0
            ],
            "countryCode": 0,
            "stateCode": provinceCode ?? 0,
            "cityCode": cityCode ?? 0,
            // "areaCode": !selectedAreasIDs[0] ? districtIDs : selectedAreasIDs[0],
            "areaCode": !selectedAreasIDs[selectedAreasIDs?.length - 1].length ? districtIDs : selectedAreasIDs[selectedAreasIDs?.length - 1],
            "priceFrom": priceFrom ? priceFrom : 0,
            "priceTo": priceTo ? priceTo : 0,
            "depositFrom": depositFrom ? depositFrom : 0,
            "depositTo": depositTo ? depositTo : 0,
            "rentFrom": rentFrom ? rentFrom : 0,
            "rentTo": rentTo ? rentTo : 0,
            "meterageFrom": meterageFrom ? meterageFrom : 0,
            "meterageTo": meterageTo ? meterageTo : 0,
            "buldingLifeFrom": buldingLifeFrom ? buldingLifeFrom : 0,
            "buldingLifeTo": buldingLifeTo ? buldingLifeTo : 0,
            "adsDateTimeFrom": selectedDate ? selectedDate[0]?.toDate()?.toISOString() : null,
            "adsDateTimeTo": selectedDate ? selectedDate[1]?.toDate()?.toISOString() : null,
            "parking": parking,
            "basement": basement,
            "elevator": elevator,
            // "addedBy": isPersonalPage ? 1 : isGenericPage ? 2 : 0
            "addedBy": isPersonal ? 1 : isGeneric ? 2 : 0,
            "onMap": props.isInOnMap ? true : null,
            "searchQuery": "",
            "numberOfRoomsFrom": numberOfRoomsFrom ? numberOfRoomsFrom : 0,
            "numberOfRoomsTo": numberOfRoomsTo ? numberOfRoomsTo : 0,
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
            },
        })
            .then((res) => {
                if (!res.data.length) {
                    setNoResult(true)
                }
                if (res.data.length < 20) {


                    setApiData(res.data)
                    setItems(res.data);
                    setHasMore(false)
                    setIsFetchData(true)
                } else {

                    setApiData(res.data)
                    setPage(page + 20);
                    setItems(res.data);
                    setIsFetchData(true)
                    setHasMore(true)
                }
            })
        setNoResult(false)
    };


    // console.log(items, "items in NewFilter");
    // console.log(!props.isSearch, "!props.isSearch in NewFilter");

    const clearPriceFrom = () => {
        setPriceFrom(null)
    }
    const clearNumberOfRoomsFrom = () => {
        setNumberOfRoomsFrom(null)
    }
    const clearNumberOfRoomsTo = () => {
        setNumberOfRoomsTo(null)
    }
    const clearPriceTo = () => {
        setPriceTo(null)
    }
    const cleareMeterageFrom = () => {
        setMeterageFrom(null)
    }
    const cleareMeterageTo = () => {
        setMeterageTo(null)
    }
    const cleareBuldingLifeFrom = () => {
        setBuldingLifeFrom(null)
    }
    const cleareBuldingLifeTo = () => {
        setBuldingLifeTo(null)
    }

    useEffect(() => {

        // const xx = selectedAreasIDs[selectedAreasIDs?.length - 1]
        updateFilterState({
            parking,
            basement,
            elevator,
            priceFrom,
            priceTo,
            numberOfRoomsFrom,
            numberOfRoomsTo
            // selectedAreasIDs: xx
            // meterageFrom,
            // meterageTo
        });
    }, [parking, basement, elevator, priceFrom, priceTo, selectedAreasIDs, meterageFrom, meterageTo, numberOfRoomsFrom, numberOfRoomsTo]);
    const handleSearch = () => {
        console.log("Search triggered with:", searchValue);
        // Your search logic here

        setLastID(false);
        filter();
        clearStorePage();
        setPage(0);
        props.setIsSearch(false);
    };
    if (props.onSearchTriggered) {
        props.onSearchTriggered.current = handleSearch;
    }

    return (
        <>
            <div className='flex items-center  w-full px-4'>
                <div className="flex items-center border border-gray-500 rounded rounded-lg  w-[100%]">
                    <div onClick={() => {
                        setIsShowFilters(true)
                        // clearStoreItems()
                        // setItems([])
                    }} className={`flex items-center ml-4`} >
                        <img src="/icons/pelake-man-filter.svg" className='w-10 h-10 p-1 filterIcon cursor-pointer' alt="" />
                        <p>فیلترها</p>
                    </div>
                    <div className="flex flex-row w-full overflow-x-scroll scroll-filter ">
                        {selectedCategoryItem != 0 ? (
                            <div onClick={async () => {
                                setSelectedCategoryItem(0)
                                setSelectedMelkTypeItem(0)
                                setSelectedMelkMoameleItem(0)
                                filter()
                            }} className="cursor-poiner rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">{selectedCategoryItem.title}</p>
                            </div>
                        ) : ""}
                        {isCommunal ? (
                            <div onClick={async () => {
                                setIsCommunal(false)
                                // updateFilterState({ isCommunal: false })
                                console.log("Clicked, isCommunal set to false");
                                await filter(false, false, false)
                            }} className="cursor-poiner rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">تعاون</p>
                            </div>
                        ) : ""}
                        {isPersonal ? (
                            <div onClick={async () => {
                                setIsPersonal(false)

                                await filter(false, false, false)
                            }} className="cursor-poiner rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">شخصی </p>
                            </div>
                        ) : ""}
                        {isGeneric ? (
                            <div onClick={async () => {
                                setIsGeneric(false)

                                await filter(false, false, false)
                            }} className="cursor-poiner rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">عمومی</p>
                            </div>
                        ) : ""}

                        {propertyCodeName != "" && (
                            <div className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center opacity-50 min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">{propertyCodeName}</p>
                            </div>
                        )}
                        {(selectedMelkTypeItem != 0 && selectedMelkTypeItem?.id) && (
                            <div onClick={async () => {
                                setSelectedMelkTypeItem(0)
                                setSelectedMelkMoameleItem(0)
                                filter()
                                updateSelectedPropertyType({})
                            }} className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center  min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">{selectedMelkTypeItem?.title}</p>
                            </div>
                        )}
                        {(selectedMelkMoameleItem != 0 && selectedMelkMoameleItem?.id) ? (
                            <div onClick={async () => {
                                setSelectedMelkMoameleItem(0)
                                filter()
                                updateSelectedTradeType({})
                            }} className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center  min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">{selectedMelkMoameleItem.title}</p>
                            </div>
                        ) : (<></>)}
                        {(priceFrom) && (
                            <div onClick={async () => {
                                setIsFilterPrice(true)
                                clearPriceFrom()
                                filter()
                            }} className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap"> {`قیمت از ${priceFrom}`}</p>
                            </div>
                        )}
                        {(priceTo) && (
                            <div onClick={async () => {
                                setIsFilterPrice(true)
                                clearPriceTo()
                                filter()
                            }} className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap"> {`قیمت تا ${priceTo}`}</p>
                            </div>
                        )}
                        {(numberOfRoomsFrom) && (
                            <div onClick={async () => {
                                clearNumberOfRoomsFrom()
                                filter()
                            }} className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap"> {`تعداد اتاق  ${numberOfRoomsFrom}`}</p>
                            </div>
                        )}
                        {/* {(numberOfRoomsTo) && (
                            <div onClick={async () => {
                                clearNumberOfRoomsTo()
                                filter()
                            }} className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap"> {`تعداد اتاق  تا ${numberOfRoomsTo}`}</p>
                            </div>
                        )} */}
                        {(meterageFrom) && (
                            <div onClick={async () => {
                                cleareMeterageFrom()
                                filter()
                            }} className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap"> {`متراژ از ${meterageFrom}`}</p>
                            </div>
                        )}
                        {(meterageTo) && (
                            <div onClick={async () => {
                                cleareMeterageTo()
                                filter()
                            }} className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap"> {`متراژ تا ${meterageTo}`}</p>
                            </div>
                        )}
                        {(buldingLifeFrom) && (
                            <div onClick={async () => {
                                cleareBuldingLifeFrom()
                                filter()
                            }} className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap"> {`عمربنا از ${buldingLifeFrom}`}</p>
                            </div>
                        )}
                        {(buldingLifeTo) && (
                            <div onClick={async () => {
                                cleareBuldingLifeTo()
                                filter()
                            }} className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap"> {`عمربنا تا ${buldingLifeTo}`}</p>
                            </div>
                        )}



                        {selectedAreas.length ? (
                            <div onClick={async () => {
                                setSelectedAreas([])
                                setSelectedAreasIDs([])
                                setIsShowPrice(false)
                                filter()
                                updateFilterState({ selectedAreasIDs: [] })

                            }} className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">محله </p>
                            </div>
                        ) : ""}

                        {adsAdvertiseTypeCode != "" ? (
                            <div onClick={async () => {
                                setAdsAdvertiseTypeCode(0)
                                filter()
                            }} className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">
                                    {adsAdvertiseTypeCode == 1 && "عادی"}
                                    {adsAdvertiseTypeCode == 2 && "حراجی"}
                                    {adsAdvertiseTypeCode == 3 && "همه"}
                                </p>
                            </div>
                        ) : ""}
                        {noeAgahiDahande != "" ? (
                            <div onClick={async () => {
                                setNoAgahiDahande(0)
                                filter()
                            }} className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">
                                    {noeAgahiDahande == 1 && "شخصی"}
                                    {noeAgahiDahande == 2 && "تجاری"}
                                    {noeAgahiDahande == 3 && "همه"}
                                </p>
                            </div>
                        ) : ""}
                        {parking ? (
                            <div onClick={async () => {
                                setParking(false)
                                // filter()
                            }} className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">پارکینگ</p>
                            </div>
                        ) : ""}
                        {basement ? (
                            <div onClick={async () => {
                                setbasement(false)
                                // filter()
                            }} className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">انباری</p>
                            </div>
                        ) : ""}
                        {elevator ? (
                            <div onClick={async () => {
                                setElevator(false)
                                // filter()
                            }} className="rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">آسانسور</p>
                            </div>
                        ) : ""}
                    </div>
                </div>
            </div>
            {/*  */}
            <div onClick={(e) => {
                if (e.target.className.includes("style-for-close-on-outside-filter")) {
                    document.removeEventListener("click", setIsShowFilters(false));
                }
            }} className={`sm:p-0 select-none pt-4 fixed style-for-close-on-outside-filter top-0 w-full mt-[5.3rem] lg:mt-[3.4rem]
              h-screen bg-[#8d8d8da1] transition-all z-40 duration-300 ${isShowFilters ? "left-0" : "left-[10000px]"} "}`}>
                <div className="sm:w-full md:w-full w-[60%] relative h-dvh z-50 bg-white overflow-y-auto pb-[67px] flex flex-col justify-between">
                    <div className="">
                        <div className="border-b borer-b-2">
                            <div className="flex items-center justify-between  px-8  py-4">
                                <p className="font-bold">فیلترآگهی ها</p>
                                <button onClick={() => clearFilters()} className="border border-red-600 text-red-600 px-4 py-1 rounded">
                                    پاکسازی فیلترها
                                </button>
                            </div>
                        </div>
                        <div className="dealTypePropertyType">
                            {/* inja */}
                            {/* <div onClick={() => { setIsShowChoseCategoryPage(true) }}
                            className={`px-6  py-2 ${props.isFilterWithPropertyCode ? "select-none opacity-50" : "opacity-100 select-auto"}`}>
                            <div className="flex items-center w-full justify-between py-2 ">
                                <div className="flex items-center gap-1">
                                    <p>دسته بندی</p>
                                    <p className="font-bold">{selectedCategoryItem != 0 ? selectedCategoryItem.title : propertyCodeName}</p>
                                </div>
                                <img src="/icons/arrow-b-f.svg" alt="go" />
                            </div>
                            <div className="w-full h-[1px] bg-gray-200"></div>
                        </div>  */}

                            <div onClick={() => { setIsShowChoseMoamelePage(true) }}
                                className={`px-6  py-2 ${props.isFilterWithPropertyCode ? "select-none opacity-50" : "opacity-100 select-auto"}`}>
                                <div className="flex items-center w-full justify-between py-2 ">
                                    <div className="flex items-center gap-1">
                                        <p> انتخاب نوع معامله</p>
                                        <p className="font-bold">{selectedCategoryItem != 0 ? selectedCategoryItem.title : propertyCodeName}</p>
                                    </div>
                                    <img src="/icons/arrow-b-f.svg" alt="go" />
                                </div>
                                <div className="w-full h-[1px] bg-gray-200"></div>
                            </div>
                            <div className={`absolute bg-white w-full  screen top-[4rem] z-40 ${(isShowChoseCategoryPage && !props.isFilterWithPropertyCode) ? "left-0 " : "left-[10000px]"}`}>
                                <div className="px-6 w-full  ">
                                    {
                                        ADS_MainCategoryCode.map(sub => (
                                            <div onClick={() => {
                                                setSelectedCategoryItem(sub)
                                                // if (sub.id == 1) {
                                                //     setIsShowChoseMoamelePage(true)
                                                // } else {
                                                //     setIsShowChoseCategoryPage(false)
                                                // }

                                                setIsShowChoseMoamelePage(true)
                                            }} key={sub.id} className="cursor-pointer flex items-center justify-between border-b py-4" >
                                                <p>{sub.title}</p>
                                                <img src="/icons/arrow-b-f.svg" alt="go" />
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>

                            <div className={`absolute bg-white w-full h-screen top-[4rem] z-50 ${isShowChoseMElkTypePage ? "left-0 " : "left-[10000px]"}`}>
                                <div className="px-6 w-full ">
                                    انتخاب نوع ملک
                                    {
                                        selectedMelkMoameleItem?.id == 6 ? (
                                            ADS_PropertyTypeCode.slice(0, 4).map(sub => (
                                                <div onClick={() => {
                                                    setSelectedMelkTypeItem(sub)
                                                    setIsShowChoseMoamelePage(false)
                                                    setIsShowChoseMElkTypePage(false)
                                                }} key={sub.id} className="cursor-pointer flex items-center justify-between border-b py-4" >
                                                    <p>{sub.title}</p>
                                                    <img src="/icons/arrow-b-f.svg" alt="go" />
                                                </div>
                                            ))
                                        ) :
                                            (
                                                ADS_PropertyTypeCode.map(sub => (
                                                    <div onClick={() => {
                                                        setSelectedMelkTypeItem(sub)
                                                        setIsShowChoseMoamelePage(false)
                                                        setIsShowChoseMElkTypePage(false)
                                                    }} key={sub.id} className="cursor-pointer flex items-center justify-between border-b py-4" >
                                                        <p>{sub.title}</p>
                                                        <img src="/icons/arrow-b-f.svg" alt="go" />
                                                    </div>
                                                ))
                                            )
                                    }
                                </div>
                            </div>
                            <div className={`pt-4 sm:pt-0 absolute bg-white w-full h-screen top-[4rem] z-50 ${isShowChoseMoamelePage ? "left-0 " : "left-[10000px]"}`}>
                                <div className="px-6 w-full ">
                                    انتخاب نوع معامله
                                    {
                                        filteredADS_PropertyTradeTypeCode
                                            .map(sub => (
                                                <div onClick={() => {
                                                    setSelectedMelkMoameleItem(sub)
                                                    setIsShowChoseCategoryPage(false)
                                                    setIsShowChoseMoamelePage(false)
                                                    if (sub.id !== 0) {
                                                        setIsShowChoseMElkTypePage(true)
                                                    } else {
                                                        setIsShowChoseMElkTypePage(false)
                                                    }
                                                }} key={sub.id} className=" cursor-pointer flex items-center justify-between border-b py-4" >
                                                    <p>{sub.title}</p>
                                                    <img src="/icons/arrow-b-f.svg" alt="go" />
                                                </div>
                                            ))
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="areas-wrapper">
                            <div className={`px-6 `}>
                                <div onClick={() => setMoveToSelectArea(true)} className="flex items-center w-full justify-between">
                                    <p className="py-2">محله </p>
                                    <img src="/icons/arrow-b-f.svg" alt="go" />
                                </div>
                                <div className="w-full h-[1px] bg-gray-200"></div>
                                <div className="flex overflow-scroll gap-2 scroll-filter ">
                                    {
                                        selectedAreas.length > 0 && selectedAreas
                                            // .filter(item => hasSubOrNot && boughtDistrictsID.includes(item.id))
                                            .map(item => (
                                                <div
                                                    onClick={async () => {
                                                        setSelectedAreas(selectedAreas.filter(finallyArea => item.id != finallyArea.id))
                                                    }}
                                                    className="cursor-pointer rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center gap-1 w-max ">
                                                    <p className="text-sm text-nowrap">{item.locName}</p>
                                                    <img src="/icons/close-red.svg" alt="حذف" />
                                                </div>
                                            ))
                                    }
                                </div>
                            </div>
                        </div>

                        {
                            selectedMelkMoameleItem !== 0 && (
                                <>
                                    {
                                        selectedMelkMoameleItem && (selectedMelkMoameleItem.id == 6) && (
                                            <>
                                                <div className="px-6  py-2">
                                                    <div onClick={() => {
                                                        setIsShowLife(false)
                                                        setIsShowRentPerMonth(false)
                                                        setIsShowDailyPrice(!isShowDailyPrice)
                                                        setIsDeposit(false)
                                                        setIsShowLife(false)
                                                        setIsShowOptions(false)
                                                        setIsShowAdsDahande(false)
                                                        setType(false)
                                                    }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                        <p>اجاره روزانه</p>
                                                        <img className={`transition-all ${isShowDailyPrice ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                    </div>
                                                    {
                                                        isShowDailyPrice ? (
                                                            <>
                                                                <div className="mb-2 flex flex-col">
                                                                    <div className="flex items-center gap-2">
                                                                        <span>از</span>
                                                                        <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                            <input
                                                                                className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                value={dailyPriceFrom}
                                                                                onChange={(e) => setDailyPriceFrom(e.target.value)}
                                                                                pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                type="tel"

                                                                            />
                                                                            <span className="p-1 border-r">تومان</span>
                                                                        </div>
                                                                    </div>
                                                                    {/* {dailyPriceFrom ? (<p className='px-5 text-[12px] text-green-600 py-1'>{(Num2persian(dailyPriceFrom))}</p>) : null} */}
                                                                </div>
                                                                <div className="mb-2 flex flex-col">
                                                                    <div className="flex items-center gap-2">
                                                                        <span>تا</span>
                                                                        <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                            <input
                                                                                value={dailyPriceTo}
                                                                                onChange={(e) => setDailyPriceTo(e.target.value)}
                                                                                className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                type="tel"

                                                                            />
                                                                            <span className="p-1 border-r">تومان</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : ""
                                                    }
                                                    <div className="w-full h-[1px] bg-gray-200"></div>
                                                </div>

                                                <div className="px-6  py-2">
                                                    <div onClick={() => {
                                                        setIsShowLife(false)
                                                        setIsShowRentPerMonth(false)
                                                        setIsShowMetrage(!isShowMetrage)
                                                        setIsDeposit(false)
                                                        setIsShowLife(false)
                                                        setIsShowOptions(false)
                                                        setIsShowAdsDahande(false)
                                                        setType(false)
                                                        setIsShowDailyPrice(false)
                                                    }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                        <p>متراژ</p>
                                                        <img className={`transition-all ${isShowMetrage ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                    </div>
                                                    {
                                                        isShowMetrage ? (
                                                            <>
                                                                <div className="mb-2 flex flex-col">
                                                                    <div className="flex items-center gap-2">
                                                                        <span>از</span>
                                                                        <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                            <input
                                                                                className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                value={meterageFrom}
                                                                                onChange={(e) => setMeterageFrom(e.target.value)}
                                                                                pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                type="tel"
                                                                                maxLength={4}
                                                                            />
                                                                            <span className="p-1 border-r">متر</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="mb-2 flex flex-col">
                                                                    <div className="flex items-center gap-2">
                                                                        <span>تا</span>
                                                                        <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                            <input
                                                                                value={meterageTo}
                                                                                onChange={(e) => setMeterageTo(e.target.value)}
                                                                                className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                type="tel"
                                                                                maxLength={4}
                                                                            />
                                                                            <span className="p-1 border-r">متر</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : ""
                                                    }
                                                    <div className="w-full h-[1px] bg-gray-200"></div>
                                                </div>

                                                <div className="px-6  py-2">
                                                    <div onClick={() => {
                                                        setIsShowOptions(!isShowOptions)
                                                        setIsShowLife(false)
                                                        setIsShowMetrage(false)
                                                        setIsShowRentPerMonth(false)
                                                        setIsDeposit(false)
                                                        setIsShowAdsDahande(false)
                                                        setType(false)
                                                    }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                        <p>امکانات</p>
                                                        <img className={`transition-all ${isShowOptions ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                    </div>
                                                    <div className="flex flex-col gap-2 mb-2">
                                                        {
                                                            isShowOptions ? (
                                                                <div className="flex items-center justify-between">
                                                                    <div onClick={() => setParking(!parking)} className="flex items-center gap-2">
                                                                        <input id="all" type="checkbox" />
                                                                        <label htmlFor="all">پارکینگ</label>
                                                                    </div>
                                                                    <div onClick={() => setbasement(!basement)} className="flex items-center gap-2">
                                                                        <input id="all" type="checkbox" />
                                                                        <label htmlFor="all">انباری</label>
                                                                    </div>
                                                                    <div onClick={() => setElevator(!elevator)} className="flex items-center gap-2">
                                                                        <input id="all" type="checkbox" />
                                                                        <label htmlFor="all">آسانسور</label>
                                                                    </div>
                                                                </div>
                                                            ) : ""
                                                        }
                                                    </div>
                                                    <div className="w-full h-[1px] bg-gray-200"></div>
                                                </div>
                                            </>
                                        )
                                    }
                                    {
                                        selectedMelkMoameleItem && (selectedMelkMoameleItem.id == 4) ? (
                                            <>
                                                <div className="px-6  py-2">
                                                    <div onClick={() => {
                                                        setIsShowLife(false)
                                                        setIsShowRentPerMonth(false)
                                                        setIsShowMetrage(!isShowMetrage)
                                                        setIsDeposit(false)
                                                        setIsShowLife(false)
                                                        setIsShowOptions(false)
                                                        setIsShowAdsDahande(false)
                                                        setType(false)
                                                        setIsShowDailyPrice(false)
                                                    }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                        <p>متراژ</p>
                                                        <img className={`transition-all ${isShowMetrage ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                    </div>
                                                    {
                                                        isShowMetrage ? (
                                                            <>
                                                                <div className="mb-2 flex flex-col">
                                                                    <div className="flex items-center gap-2">
                                                                        <span>از</span>
                                                                        <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                            <input
                                                                                className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                value={meterageFrom}
                                                                                onChange={(e) => setMeterageFrom(e.target.value)}
                                                                                pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                type="tel"
                                                                                maxLength={4}
                                                                            />
                                                                            <span className="p-1 border-r">متر</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="mb-2 flex flex-col">
                                                                    <div className="flex items-center gap-2">
                                                                        <span>تا</span>
                                                                        <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                            <input
                                                                                value={meterageTo}
                                                                                onChange={(e) => setMeterageTo(e.target.value)}
                                                                                className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                type="tel"
                                                                                maxLength={4}
                                                                            />
                                                                            <span className="p-1 border-r">متر</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : ""
                                                    }
                                                    <div className="w-full h-[1px] bg-gray-200"></div>
                                                </div>
                                            </>
                                        ) : (
                                            selectedMelkMoameleItem && (selectedMelkMoameleItem.id == 2) ? (<>
                                                <div className="px-6  py-2">
                                                    <div onClick={() => {
                                                        setIsDeposit(!isShowDeposit)
                                                        setIsShowRentPerMonth(false)
                                                        setIsShowLife(false)
                                                        setIsShowMetrage(false)
                                                        setIsShowOptions(false)
                                                        setIsShowAdsDahande(false)
                                                        setType(false)
                                                    }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                        <p>
                                                            ودیعه
                                                        </p>
                                                        <img className={`transition-all ${isShowDeposit ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                    </div>
                                                    {
                                                        isShowDeposit ? (
                                                            <>
                                                                <div className="mb-2 flex flex-col">
                                                                    <div className="flex items-center gap-2">
                                                                        <span>از</span>
                                                                        <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                            <input
                                                                                value={depositFrom}
                                                                                onChange={(e) => setDepositFrom(e.target.value)}
                                                                                className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                type="tel"
                                                                            />
                                                                            <span className="p-1 border-r">تومان</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="mb-2 flex flex-col">
                                                                    <div className="flex items-center gap-2">
                                                                        <span>تا</span>
                                                                        <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                            <input
                                                                                className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                value={depositTo}
                                                                                onChange={(e) => setDepositTo(e.target.value)}
                                                                                pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                type="tel"
                                                                                maxLength={19}
                                                                            />
                                                                            <span className="p-1 border-r">تومان</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : ""
                                                    }
                                                    <div className="w-full h-[1px] bg-gray-200"></div>
                                                </div>
                                                <div className="px-6  py-2">
                                                    <div onClick={() => {
                                                        setIsShowRentPerMonth(!isShowRentPerMonth)
                                                        setIsDeposit(false)
                                                        setIsShowLife(false)
                                                        setIsShowMetrage(false)
                                                        setIsShowOptions(false)
                                                        setIsShowAdsDahande(false)
                                                        setType(false)
                                                    }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                        <p>
                                                            اجاره
                                                        </p>
                                                        <img className={`transition-all ${isShowRentPerMonth ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                    </div>
                                                    {
                                                        isShowRentPerMonth ? (
                                                            <>
                                                                <div className="mb-2 flex flex-col">
                                                                    <div className="flex items-center gap-2">
                                                                        <span>از</span>
                                                                        <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                            <input
                                                                                value={rentFrom}
                                                                                onChange={(e) => setRentFrom(e.target.value)}
                                                                                className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                maxLength={19}
                                                                            />
                                                                            <span className="p-1 border-r">تومان</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="mb-2 flex flex-col">
                                                                    <div className="flex items-center gap-2">
                                                                        <span>تا</span>
                                                                        <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                            <input
                                                                                value={rentTo}
                                                                                onChange={(e) => setRentTo(e.target.value)}
                                                                                className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                type="tel"
                                                                                maxLength={19}
                                                                            />
                                                                            <span className="p-1 border-r">تومان</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : ""
                                                    }
                                                    <div className="w-full h-[1px] bg-gray-200"></div>
                                                </div>
                                            </>) : (<>
                                                {
                                                    selectedMelkMoameleItem && (selectedMelkMoameleItem.id != 6) && (
                                                        <>
                                                            {/* <div className="px-6  py-2">
                                                            <div onClick={() => {
                                                                setIsShowPricePerMeter(!isShowPricePerMeter)
                                                            }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                                <p>
                                                                    قیمت متری
                                                                </p>
                                                                <img className={`transition-all ${isShowPricePerMeter ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                            </div>
                                                            {
                                                                isShowPricePerMeter ? (
                                                                    <>
                                                                        <div className="mb-2 flex flex-col">
                                                                            <div className="flex items-center gap-2">
                                                                                <span>از</span>
                                                                                <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                                    <input
                                                                                        className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                        value={FormatPrice(
                                                                                            ConvertPersianToEnglish(pricePerMeterFrom)
                                                                                        )}
                                                                                        type="tel"
                                                                                        maxLength={19}
                                                                                        onChange={(e) => {
                                                                                            const newValue = e.target.value.replace(
                                                                                                /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                                                                ""
                                                                                            );
                                                                                            setPricePerMeterFrom(ConvertPersianToEnglish(newValue));

                                                                                        }}
                                                                                        pattern="[0-9۰-۹آ-ی‌ ‍٬]*"

                                                                                    />
                                                                                    <span className="p-1 border-r">تومان</span>
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                {pricePerMeterFrom && (
                                                                                    <p className="px-3 text-[12px] text-green-600">
                                                                                        {Num2persian(pricePerMeterFrom)} تومان
                                                                                    </p>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-2 flex flex-col">
                                                                            <div className="flex items-center gap-2">
                                                                                <span>تا</span>
                                                                                <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                                    <input
                                                                                        className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                        value={FormatPrice(
                                                                                            ConvertPersianToEnglish(pricePerMeterTo)
                                                                                        )}
                                                                                        onChange={(e) => {
                                                                                            const newValue = e.target.value.replace(
                                                                                                /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                                                                ""
                                                                                            );
                                                                                            setPricePerMeterTo(ConvertPersianToEnglish(newValue));

                                                                                        }}

                                                                                        pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                        type="tel"
                                                                                        maxLength={19}
                                                                                    />
                                                                                    <span className="p-1 border-r">تومان</span>
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                {pricePerMeterTo && (
                                                                                    <p className="px-3 text-[12px] text-green-600">
                                                                                        {Num2persian(pricePerMeterTo)} تومان
                                                                                    </p>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                ) : ""
                                                            }
                                                            <div className="w-full h-[1px] bg-gray-200"></div>
                                                        </div> */}
                                                            <div className="px-6  py-2">
                                                                <div onClick={() => {
                                                                    setIsShowPriceTotal(!isShowPriceTotal)
                                                                }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                                    <p>
                                                                        قیمت کل
                                                                    </p>
                                                                    <img className={`transition-all ${isShowPriceTotal ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                                </div>
                                                                {
                                                                    isShowPriceTotal ? (
                                                                        <>
                                                                            <div className="mb-2 flex flex-col">
                                                                                <div className="flex items-center gap-2">
                                                                                    <span>از</span>
                                                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                                        <input
                                                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                            value={FormatPrice(
                                                                                                ConvertPersianToEnglish(priceTotalFrom)
                                                                                            )}

                                                                                            onChange={(e) => {
                                                                                                const newValue = e.target.value.replace(
                                                                                                    /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                                                                    ""
                                                                                                );
                                                                                                setPriceTotalFrom(ConvertPersianToEnglish(newValue));

                                                                                            }}
                                                                                            pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                            type="tel"
                                                                                            maxLength={19}
                                                                                        />
                                                                                        <span className="p-1 border-r">تومان</span>
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    {priceTotalFrom && (
                                                                                        <p className="px-3 text-[12px] text-green-600">
                                                                                            {Num2persian(priceTotalFrom)} تومان
                                                                                        </p>
                                                                                    )}
                                                                                </div>

                                                                            </div>
                                                                            <div className="mb-2 flex flex-col">
                                                                                <div className="flex items-center gap-2">
                                                                                    <span>تا</span>
                                                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                                        <input
                                                                                            className="w-full px-6 text-right dir-ltr bg-transparent"

                                                                                            value={FormatPrice(
                                                                                                ConvertPersianToEnglish(priceTotalTo)
                                                                                            )}
                                                                                            onChange={(e) => {
                                                                                                const newValue = e.target.value.replace(
                                                                                                    /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                                                                    ""
                                                                                                );
                                                                                                setPriceTotalTo(ConvertPersianToEnglish(newValue));

                                                                                            }}
                                                                                            pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                            type="tel"
                                                                                            maxLength={19}
                                                                                        />
                                                                                        <span className="p-1 border-r">تومان</span>
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    {priceTotalTo && (
                                                                                        <p className="px-3 text-[12px] text-green-600">
                                                                                            {Num2persian(priceTotalTo)} تومان
                                                                                        </p>
                                                                                    )}
                                                                                </div>

                                                                            </div>
                                                                        </>
                                                                    ) : ""
                                                                }
                                                                <div className="w-full h-[1px] bg-gray-200"></div>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </>)
                                        )
                                    }

                                    {
                                        selectedMelkMoameleItem && (selectedMelkMoameleItem.id != 4) && (selectedMelkMoameleItem.id != 6) && (
                                            <>
                                                <div className="px-6  py-2">
                                                    <div onClick={() => {
                                                        setIsShowLife(false)
                                                        setIsShowRentPerMonth(false)
                                                        setIsShowMetrage(!isShowMetrage)
                                                        setIsDeposit(false)
                                                        setIsShowLife(false)
                                                        setIsShowOptions(false)
                                                        setIsShowAdsDahande(false)
                                                        setType(false)
                                                        setIsShowDailyPrice(false)
                                                    }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                        <p>متراژ</p>
                                                        <img className={`transition-all ${isShowMetrage ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                    </div>
                                                    {
                                                        isShowMetrage ? (
                                                            <>
                                                                <div className="mb-2 flex flex-col">
                                                                    <div className="flex items-center gap-2">
                                                                        <span>از</span>
                                                                        <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                            <input
                                                                                className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                value={meterageFrom}
                                                                                onChange={(e) => setMeterageFrom(e.target.value)}
                                                                                pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                type="tel"
                                                                                maxLength={4}
                                                                            />
                                                                            <span className="p-1 border-r">متر</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="mb-2 flex flex-col">
                                                                    <div className="flex items-center gap-2">
                                                                        <span>تا</span>
                                                                        <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                            <input
                                                                                value={meterageTo}
                                                                                onChange={(e) => setMeterageTo(e.target.value)}
                                                                                className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                type="tel"

                                                                            />
                                                                            <span className="p-1 border-r">متر</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : ""
                                                    }
                                                    <div className="w-full h-[1px] bg-gray-200"></div>
                                                </div>
                                                <div className="px-6  py-2">
                                                    <div onClick={() => {
                                                        setIsShowMetrage(false)
                                                        setIsShowLife(!isShowLife)
                                                        setIsShowRentPerMonth(false)
                                                        setIsDeposit(false)
                                                        setIsShowOptions(false)
                                                        setIsShowAdsDahande(false)
                                                        setType(false)
                                                    }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                        <p>عمر بنا</p>
                                                        <img className={`transition-all ${isShowLife ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                    </div>
                                                    {
                                                        isShowLife ? (
                                                            <>
                                                                <div className="mb-2 flex flex-col">
                                                                    <div className="flex items-center gap-2">
                                                                        <span>از</span>
                                                                        <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                            <input
                                                                                className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                type="tel"
                                                                                value={buldingLifeFrom}
                                                                                onChange={(e) => setBuldingLifeFrom(e.target.value)}
                                                                            />
                                                                            <span className="p-1 border-r">سال</span>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                <div className="mb-2 flex flex-col">
                                                                    <div className="flex items-center gap-2">
                                                                        <span>تا</span>
                                                                        <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                            <input
                                                                                value={buldingLifeTo}
                                                                                onChange={(e) => setBuldingLifeTo(e.target.value)}
                                                                                className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                type="tel"

                                                                            />
                                                                            <span className="p-1 border-r">سال</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : ""
                                                    }
                                                    <div className="w-full h-[1px] bg-gray-200"></div>
                                                </div>
                                                <div className="px-6  py-2">
                                                    <div onClick={() => {
                                                        setIsShowOptions(!isShowOptions)
                                                        setIsShowLife(false)
                                                        setIsShowMetrage(false)
                                                        setIsShowRentPerMonth(false)
                                                        setIsDeposit(false)
                                                        setIsShowAdsDahande(false)
                                                        setType(false)
                                                    }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                        <p>امکانات</p>
                                                        <img className={`transition-all ${isShowOptions ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                    </div>
                                                    <div className="flex flex-col gap-2 mb-2">
                                                        {
                                                            isShowOptions ? (
                                                                <div className="flex items-center justify-between">
                                                                    <div onClick={() => setParking(!parking)} className="flex items-center gap-2">
                                                                        <input id="all" type="checkbox" />
                                                                        <label htmlFor="all">پارکینگ</label>
                                                                    </div>
                                                                    <div onClick={() => setbasement(!basement)} className="flex items-center gap-2">
                                                                        <input id="all" type="checkbox" />
                                                                        <label htmlFor="all">انباری</label>
                                                                    </div>
                                                                    <div onClick={() => setElevator(!elevator)} className="flex items-center gap-2">
                                                                        <input id="all" type="checkbox" />
                                                                        <label htmlFor="all">آسانسور</label>
                                                                    </div>
                                                                </div>
                                                            ) : ""
                                                        }
                                                    </div>
                                                    <div className="w-full h-[1px] bg-gray-200"></div>
                                                </div>
                                            </>
                                        )
                                    }

                                </>
                            )
                        }
                        {/* {
                        !props.userCode && (
                            <div className="px-6  py-2">
                                <div onClick={() => {
                                    setIsShowOptions(false)
                                    setIsShowAdsDahande(!isShowTypeAdsDahande)
                                    setIsShowLife(false)
                                    setIsShowMetrage(false)
                                    setIsShowRentPerMonth(false)
                                    setIsDeposit(false)
                                    setType(false)
                                }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                    <p>نوع آگهی دهنده</p>
                                    <img className={`transition-all ${isShowTypeAdsDahande ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                </div>
                                {
                                    isShowTypeAdsDahande ? (
                                        <>
                                            <div className="flex justify-between gap-2 mb-2">
                                                <div onClick={() => setNoAgahiDahande(noeAgahiDahande == 0 ? null : 0)} className="flex items-center gap-2">
                                                    <input checked={noeAgahiDahande == 0 && true} id="all" type="checkbox" defaultChecked={noeAgahiDahande == 0 ? true : false} />
                                                    <label htmlFor="all" >همه</label>
                                                </div>
                                                <div onClick={() => setNoAgahiDahande(2)} className="flex items-center gap-2">
                                                    <input checked={noeAgahiDahande == 0 ? true : noeAgahiDahande == 2 && true} id="busi" type="checkbox" />
                                                    <label htmlFor="busi">تجاری</label>
                                                </div>
                                                <div onClick={() => setNoAgahiDahande(1)} className="flex items-center gap-2">
                                                    <input checked={noeAgahiDahande == 0 ? true : noeAgahiDahande == 1 && true} id="personal" type="checkbox" />
                                                    <label htmlFor="personal">شخصی</label>
                                                </div>
                                            </div>
                                        </>
                                    ) : ""
                                }
                                <div className="w-full h-[1px] bg-gray-200"></div>
                            </div>
                        )
                    } */}
                        {
                            selectedCategoryItem == 0 && selectedCategoryItem.id != 1 && (
                                <div className="px-6  py-2">
                                    <div onClick={() => {
                                        setIsShowPrice(!isShowPrice)
                                    }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                        <p>
                                            قیمت
                                        </p>
                                        <img className={`transition-all ${isShowPrice ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                    </div>
                                    {
                                        isShowPrice ? (
                                            <>
                                                <div className="mb-2 flex flex-col">
                                                    <div className="flex items-center gap-2">

                                                        <div className="flex flex-col">
                                                            <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                <span>از</span>
                                                                <input
                                                                    className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                    value={FormatPrice(
                                                                        ConvertPersianToEnglish(priceFrom)
                                                                    )}
                                                                    onChange={(e) => {
                                                                        const newValue = e.target.value.replace(
                                                                            /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                                            ""
                                                                        );
                                                                        setPriceFrom(ConvertPersianToEnglish(newValue));

                                                                    }}
                                                                    pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                                                    type="tel"
                                                                    maxLength={19}
                                                                />
                                                                <span className="p-1 border-r">تومان</span>

                                                            </div>
                                                            <div>
                                                                {priceFrom && (
                                                                    <p className="px-3 text-[12px] text-green-600">
                                                                        {Num2persian(priceFrom)} تومان
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mb-2 flex flex-col">
                                                    <div className="flex items-center gap-2">
                                                        <div className="flex flex-col">
                                                            <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                <span>تا</span>
                                                                <input
                                                                    className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                    value={FormatPrice(
                                                                        ConvertPersianToEnglish(priceTo)
                                                                    )}
                                                                    onChange={(e) => {
                                                                        const newValue = e.target.value.replace(
                                                                            /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                                            ""
                                                                        );
                                                                        setPriceTo(ConvertPersianToEnglish(newValue));

                                                                    }}
                                                                    pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                                                    type="tel"
                                                                    maxLength={19}
                                                                />
                                                                <span className="p-1 border-r">تومان</span>
                                                            </div>
                                                            <div>
                                                                {priceTo && (
                                                                    <p className="px-3 text-[12px] text-green-600">
                                                                        {Num2persian(priceTo)} تومان
                                                                    </p>
                                                                )}

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ) : ""
                                    }
                                    <div className="w-full h-[1px] bg-gray-200"></div>
                                </div>
                            )
                        }
                        {
                            selectedCategoryItem == 0 && selectedCategoryItem.id != 1 && (
                                <div className="px-6  py-2">
                                    <div onClick={() => {
                                        setIsRoomNumber(!isRoomNumber)
                                    }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                        <p>
                                            تعداد اتاق
                                        </p>
                                        <img className={`transition-all ${isShowPrice ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                    </div>
                                    {
                                        isRoomNumber ? (
                                            <>
                                                <div className="mb-2 flex flex-col">
                                                    <div className="flex items-center gap-2">

                                                        <div className="flex flex-col">
                                                            <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                {/* <span>از</span> */}
                                                                <input
                                                                    className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                    value={numberOfRoomsFrom}
                                                                    onChange={(e) => {
                                                                        const newValue = e.target.value.replace(
                                                                            /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                                            ""
                                                                        );
                                                                        setNumberOfRoomsFrom(ConvertPersianToEnglish(newValue));

                                                                    }}
                                                                    pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                                                    type="tel"
                                                                    maxLength={19}
                                                                />


                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div className="mb-2 flex flex-col">
                                                    <div className="flex items-center gap-2">
                                                        <div className="flex flex-col">
                                                            <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                <span>تا</span>
                                                                <input
                                                                    className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                    value={
                                                                        numberOfRoomsTo
                                                                    }
                                                                    onChange={(e) => {
                                                                        const newValue = e.target.value.replace(
                                                                            /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                                            ""
                                                                        );
                                                                        setNumberOfRoomsTo(ConvertPersianToEnglish(newValue));

                                                                    }}
                                                                    pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                                                    type="tel"
                                                                    maxLength={19}
                                                                />

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div> */}
                                            </>
                                        ) : ""
                                    }
                                    <div className="w-full h-[1px] bg-gray-200"></div>
                                </div>
                            )
                        }
                        {

                            <div className="px-6  py-2">
                                <div onClick={toggleCalendar} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                    <p>
                                        تاریخ
                                    </p>
                                    {/* <img className={`transition-all ${isShowPrice ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" /> */}
                                    {localStorage.getItem('veeu-dark-mode') === "true" ? <img src="/icons/white-icons/white-calander.svg" alt="تقویم" /> : <img src="/icons/new-filter-calendar.svg" alt="تقویم" />}
                                </div>
                                {
                                    isCalendarOpen && (
                                        <DatePicker
                                            style={localStorage.getItem("veeu-dark-mode") === "true" ? { color: "black", backgroundColor: "white" } : {}}
                                            ref={datePickerRef}
                                            className='green'
                                            range
                                            dateSeparator=" تا "
                                            multipleRangeSeparator='&'
                                            calendar={persian}
                                            locale={persian_fa}
                                            calendarPosition='bottom-right'
                                            value={selectedDate}
                                            onChange={setSelectedDate}
                                            open={true}
                                            // onOpen={true}
                                            hideOnScroll={false}
                                            inputClass="custom-input-NewFilter"
                                        />
                                    )
                                }
                                {/*  */}
                                <div className="w-full h-[1px] bg-gray-200"></div>
                            </div>

                        }
                        {

                            <div className="px-6  py-2">
                                <div onClick={() => SetIsNoeAgahaiVisible(!isNoeAgahaiVisible)} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                    <p>
                                        نوع آگهی
                                    </p>
                                    <img className={`transition-all ${isNoeAgahaiVisible ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                </div>
                                {
                                    isNoeAgahaiVisible ? (
                                        <>
                                            <div className="mb-2 flex flex-col">
                                                {adTypes?.map((adType, index) =>
                                                (
                                                    <div className="" key={index} onClick={() => toggleSelect(adType)}>
                                                        <div className="flex items-center mb-1  text-[14px] font-medium" >
                                                            <div
                                                                className={`w-[20px] h-[20px] border ml-1 border-gray-400 rounded-full ${selectedAdTypes?.id === adType.id
                                                                    ? "bg-gray-400"
                                                                    : "border-[2px] bg-white"
                                                                    }`}
                                                            ></div>
                                                            {adType?.title}
                                                        </div>
                                                        <div className="text-[#8B8B8B] text-[14px]">
                                                            {adType?.desc}
                                                        </div>
                                                        <div className="bg-[#E3E3E3] h-[1px] w-full my-4"></div>
                                                    </div>)

                                                )}
                                            </div>
                                        </>
                                    ) : ""
                                }
                                {/*  */}
                                <div className="w-full h-[1px] bg-gray-200"></div>
                            </div>

                        }
                        {/* {console.log(selectedDate, "selectedDate selectedDate")
                    }
                    {console.log(selectedDate[0]?.toDate()?.toISOString(), "selectedDate selectedDate 0")
                    }
                    {console.log(selectedDate[1]?.toDate()?.toISOString(), "selectedDate selectedDate 1")
                    } */}
                        {/* {
                        selectedMelkMoameleItem && (selectedMelkMoameleItem.id != 4) && (selectedMelkMoameleItem.id != 6) ? (
                            <div className={`px-6  py-2 ${selectedCategoryItem && selectedCategoryItem.id !== 1 ? " opacity-40 pointer-events-none" : "opacity-100 pointer-events-auto"}`}>
                                <div onClick={() => {
                                    setType(!type)
                                    setIsShowOptions(false)
                                    setIsShowAdsDahande(false)
                                    setIsShowLife(false)
                                    setIsShowMetrage(false)
                                    setIsShowRentPerMonth(false)
                                    setIsDeposit(false)
                                }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                    <p>نوع آگهی </p>
                                    <img className={`transition-all ${type ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                </div>
                                {
                                    type ? (
                                        <>
                                            <div className="flex justify-between gap-2 mb-2">
                                                <div onClick={() => setAdsAdvertiseTypeCode(adsAdvertiseTypeCode == 0 ? null : 0)} className="flex items-center gap-2">
                                                    <input checked={adsAdvertiseTypeCode == 0 && true} id="all" type="checkbox" />
                                                    <label htmlFor="all">همه</label>
                                                </div>
                                                <div onClick={() => setAdsAdvertiseTypeCode(1)} className="flex items-center gap-2">
                                                    <input checked={adsAdvertiseTypeCode == 0 ? true : adsAdvertiseTypeCode == 1 && true} id="busi" type="checkbox" />
                                                    <label htmlFor="busi">عادی</label>
                                                </div>
                                                <div onClick={() => setAdsAdvertiseTypeCode(2)} className="flex items-center gap-2">
                                                    <input checked={adsAdvertiseTypeCode == 0 ? true : adsAdvertiseTypeCode == 2 && true} id="personal" type="checkbox" />
                                                    <label htmlFor="personal">حراجی</label>
                                                </div>
                                            </div>
                                        </>
                                    ) : ""
                                }
                                <div className="w-full h-[1px] bg-gray-200"></div>
                            </div>
                        ) : ""
                    } */}
                        {
                            moveToSelectArea ? (
                                <div className="absolute top-0 w-full h-screen bg-white z-50  overflow-auto scroll-filter">
                                    <div className="sticky top-0 bg-white">
                                        <div className="flex items-center w-full justify-between border-b p-5">
                                            <p className="font-bold">انتخاب محله</p>
                                            <img onClick={() => setMoveToSelectArea(false)} src="/icons/close-black.svg" alt="close" />
                                        </div>
                                        <div className="p-4">
                                            <div className="bg-gray-100 rounded flex items-center justify-between w-full p-2 ">
                                                <input value={searchInCitiesValue} onChange={(e) => searchInCitiesHandler(e)} className="bg-transparent" type="text" maxLength={320} placeholder="جست و جو محل" />
                                                <img src="/icons/search.svg" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="inline-flex overflow-scroll gap-1 scroll-filter w-[95%] ">
                                        {
                                            selectedAreas.length > 0 && selectedAreas.map(item => (
                                                <div
                                                    onClick={async () => {
                                                        setSelectedAreas(selectedAreas.filter(finallyArea => item.id != finallyArea.id))
                                                    }}
                                                    className="cursor-pointer rounded-lg border border-[#747474] m-1 px-1 text-[#747474] flex items-center gap-1 w-max">
                                                    <p className="text-sm text-nowrap w-max">{item.locName}</p>
                                                    <img src="/icons/close-red.svg" className="w-max" alt="حذف" />
                                                </div>
                                            ))
                                        }
                                    </div>
                                    <div className="px-6 w-full h-screen ">
                                        <div className="flex flex-col gap-2 mb-2">
                                            {
                                                cityState && cityState.length ? cityState
                                                    .filter(item => !hasSubOrNot || boughtDistrictsID.includes(item.id))
                                                    .map(item => (
                                                        <>
                                                            <div className="flex items-center gap-2 border-b pb-3">
                                                                <label onClick={async () => {
                                                                    toggleItem(item)
                                                                    setIsShowPrice(!isShowPrice)
                                                                }} htmlFor={`location${item.id}`}>
                                                                    <div className="flex cursor-pointer  items-center gap-1" >
                                                                        <div className={`w-[15px] h-[15px] border rounded-full
                                                             ${selectedAreas.find((area) => area.id == item.id) ? "border-main bg-main" : "border-green-500 bg-white"}`}></div>
                                                                        {/* <input checked={selectedAreas.find((area) => area.id == item.id)} id={`location${item.id}`} name={item.id} type="checkbox" /> */}
                                                                        <p>{item.locName}</p>
                                                                    </div>
                                                                    <p className="">
                                                                        {
                                                                            item.subAreas ? item.subAreas.map((sub, index) => (
                                                                                <span className="text-sm text-gray-600 ">{sub}
                                                                                    {
                                                                                        item.subAreas.length != index + 1 && "-"
                                                                                    }
                                                                                </span>
                                                                            )) : ""
                                                                        }
                                                                    </p>
                                                                </label>
                                                            </div>
                                                        </>
                                                    )) : ""
                                            }
                                        </div>
                                    </div>

                                </div>
                            ) : ""
                        }
                        {/* <div className={`${moveToSelectArea || isShowChoseMoamelePage || isShowChoseMElkTypePage || isShowChoseCategoryPage ? "grid-cols-1 " : "grid-cols-2 "}
                     absolute  bottom-[5.5rem] lg:bottom-[4.5rem] w-full grid px-6 py-4 gap-4 border-t bg-white z-50`}>
                        <button onClick={() => {
                            setIsButtonActive(false)
                            setLastID(false)
                            filter()
                            clearStorePage()
                            setPage(0)
                        }} className={`bg-blue-500 text-white 
                        ${moveToSelectArea || isShowChoseMoamelePage || isShowChoseMElkTypePage || isShowChoseCategoryPage ? "hidden" : "inline"}
                        rounded  py-1 z-50 ${!isButtonActive && `opacity-55`}`}> {isButtonActive ? " اعمال فیلتر ها " : " در حال پردازش"}            </button>
                        <button onClick={() => {
                            // setIsFilterPrice(true)
                            if (moveToSelectArea) {
                                setMoveToSelectArea(false)
                            }
                            else if (isShowChoseMoamelePage) {
                                setIsShowChoseMoamelePage(false)
                            }
                            else if (isShowChoseMElkTypePage) {
                                setIsShowChoseMElkTypePage(false)
                            }
                            else if (isShowChoseCategoryPage) {
                                setIsShowChoseCategoryPage(false)
                            }
                            else {
                                setIsShowFilters(false)
                            }
                        }} className="border border-blue-500 text-blue-500 rounded  py-1 z-50">بازگشت</button>
                    </div> */}
                    </div>
                    <div className=" w-full mt-3 bg-white z-50 px-6 py-4 border-t grid grid-cols-2 gap-4 mb-9 lg:mb-0">
                        <button onClick={() => {
                            setIsButtonActive(false);
                            setSearchValue("")
                            setLastID(false);
                            filter();
                            clearStorePage();
                            setPage(0);
                        }} className={`bg-blue-500 text-white rounded py-1 ${!isButtonActive && 'opacity-55'}`}>
                            {isButtonActive ? "اعمال فیلتر ها" : "در حال پردازش"}
                        </button>
                        <button onClick={() => {
                            if (moveToSelectArea) {
                                setMoveToSelectArea(false);
                            } else if (isShowChoseMoamelePage) {
                                setIsShowChoseMoamelePage(false);
                            } else if (isShowChoseMElkTypePage) {
                                setIsShowChoseMElkTypePage(false);
                            } else if (isShowChoseCategoryPage) {
                                setIsShowChoseCategoryPage(false);
                            } else {
                                setIsShowFilters(false);
                            }
                        }} className="border border-blue-500 text-blue-500 rounded py-1">
                            بازگشت
                        </button>
                    </div>
                </div>
            </div >
            {
                !props.isInOnMap && (
                    (storeItems.length && !props.userCode) ?
                        (<>
                            <div className="w-full">
                                <div className='px-[10px] mt-2 w-full' id="adsSection">
                                    <div className={`relative px-4 mt-2 grid  sm:grid-cols-1 md:grid-cols-2  gap-[10px] sm:gap-[0px] 
                                                            ${props.userCode ? "grid-cols-2 lg:grid-cols-1 md:grid-cols-1 xl:grid-cols-2 " : "grid-cols-4 lg:grid-cols-3 xl:grid-cols-3  md:grid-cols-2 "} `}
                                    >
                                        {/* {
                                            storeItems.filter(storeItem => storeItem.adsAdvertiseTypeCode == 2).map(storeItem => {
                                                return (
                                                    <OneCard key={storeItem.id} item={storeItem}
                                                    />)
                                            }
                                            )
                                        } */}
                                    </div>
                                </div>
                                <div className='px-[10px] mt-4 sm:mt-1 mx-2'>
                                    <div className={`relative mt-2 grid  sm:grid-cols-1 md:grid-cols-2  gap-[10px] sm:gap-[0px] 
                                                            ${props.userCode ? "grid-cols-2 lg:grid-cols-1 md:grid-cols-1 xl:grid-cols-2 " : "grid-cols-4 lg:grid-cols-3 xl:grid-cols-3  md:grid-cols-2"} `}
                                    >
                                        {

                                            storeItems.filter(storeItem => storeItem.adsAdvertiseTypeCode !== 2).map(storeItem => {
                                                // const isViewed = viewedAdIds.includes(storeItem.id);
                                                return (
                                                    // storeItem.adsAdvertiseShowTypeCode == 2 ?
                                                    //     (
                                                    //         <div className="row-span-2 grid">
                                                    //             <OneCard key={storeItem.id} item={storeItem} />
                                                    //         </div>
                                                    //     ) : (
                                                    //         <TwoCard key={storeItem.id} item={storeItem} />
                                                    //     )
                                                    // <div className={`${isViewed ? 'border-red-500' : 'border-gray-300'}`}>
                                                    <TwoCard key={storeItem.id} item={storeItem} />
                                                    // </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                <div ref={bottomBoundaryRef} style={{ height: '1px' }} />

                                {hasMoreThanStoreItems &&
                                    (
                                        loader ? (<Loader isLoaderTop={true} />) : (
                                            <>
                                                {
                                                    !props.isSearch ? (
                                                        <>
                                                            <InfiniteScroll
                                                                pageStart={0}
                                                                loadMore={fetchData}
                                                                hasMore={hasMore}
                                                                loader={
                                                                    <div className="w-full flex items-center justify-center gap-2 font-bold text-center my-4" key={0}>
                                                                        <p>  درحال بارگذاری</p>
                                                                        <div class="loading">
                                                                            <span class="loading__dot"></span>
                                                                            <span class="loading__dot"></span>
                                                                            <span class="loading__dot"></span>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            >
                                                                <div className='px-[10px] mt-2 w-full ' id="adsSection">
                                                                    <div className={`relative mt-2 grid  sm:grid-cols-1 md:grid-cols-2  gap-[10px] sm:gap-[0px] 
                                                                    ${props.userCode ? "grid-cols-2 lg:grid-cols-1 md:grid-cols-1 xl:grid-cols-2 " : "grid-cols-4 lg:grid-cols-3 xl:grid-cols-3  md:grid-cols-2 "} `}
                                                                        onClick={() => addItemsInStore(items, page)}>
                                                                        {/* {
                                                                            items.filter(item => item.adsAdvertiseTypeCode == 2).map(item => (
                                                                                <OneCard key={item.id} item={item}
                                                                                />
                                                                            ))
                                                                        } */}
                                                                    </div>
                                                                </div>
                                                                <div className='px-[10px] mt-4 sm:mt-1 w-full'>
                                                                    <div className={`relative mt-2 grid  sm:grid-cols-1 md:grid-cols-2  gap-[10px] sm:gap-[0px] 
                                                                    ${props.userCode ? "grid-cols-2 lg:grid-cols-1 md:grid-cols-1 xl:grid-cols-2 " : "grid-cols-4 lg:grid-cols-3 xl:grid-cols-3  md:grid-cols-2"} `}
                                                                        onClick={() => addItemsInStore(items, page)}>
                                                                        {
                                                                            // items.filter(item => item.adsAdvertiseTypeCode !== 2).map(item => (
                                                                            items.map(item => (
                                                                                // item.adsAdvertiseShowTypeCode == 2 ? (
                                                                                //     <div className="row-span-2 grid">
                                                                                //         <OneCard key={item.id} item={item} />
                                                                                //     </div>
                                                                                // ) : (

                                                                                <TwoCard key={item.id} item={item} />

                                                                                // )
                                                                            ))
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </InfiniteScroll>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className='px-1 mb-24'>
                                                                <div className={`relative grid gap-2  grid-cols-4 lg:grid-cols-2 xl:grid-cols-3  md:grid-cols-2 sm:grid-cols-1 kelas `}>
                                                                    {
                                                                        // allMasterOrders.length ? allMasterOrders.filter(item => item.adsAdvertiseTypeCode !== 2).map(item => (
                                                                        allMasterOrders.length ? allMasterOrders.map(item => (
                                                                            // item.adsAdvertiseShowTypeCode == 2 ? (
                                                                            //     <OneCard key={item.id} item={item} />
                                                                            // ) : (

                                                                            <TwoCard key={item.id} item={item} />

                                                                            // )
                                                                        )) : (
                                                                            <div className='flex items-center justify-center flex-col w-full absolute '>
                                                                                <p className='font-bold text-center'>آگهی با  مشخصات مورد نظر یافت نشد 1</p>
                                                                                <button onClick={async () => {
                                                                                    await props.setIsSearch(false)
                                                                                    await clearLocations()
                                                                                    props.setSearchValue("")
                                                                                    localStorage.setItem("locationNameVeeu", JSON.stringify({ id: 3, locName: "تهران" }))
                                                                                    showAllAdss()

                                                                                }
                                                                                } className='bg-main px-8 py-1 text-white rounded mb-12'>نمایش همه آگهی ها</button>
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </>
                                        )
                                    )}

                            </div>
                        </>) :
                        (
                            loader ? (<Loader isLoaderTop={true} />) : (
                                <>
                                    {
                                        !props.isSearch ? (
                                            <div className="w-full">
                                                <InfiniteScroll
                                                    pageStart={0}
                                                    loadMore={fetchData}
                                                    hasMore={hasMore}
                                                    loader={
                                                        <div className="w-full flex items-center justify-center gap-2 font-bold text-center my-4" key={0}>
                                                            <p>  درحال بارگذاری</p>
                                                            <div class="loading">
                                                                <span class="loading__dot"></span>
                                                                <span class="loading__dot"></span>
                                                                <span class="loading__dot"></span>
                                                            </div>
                                                        </div>
                                                    }
                                                >

                                                    <div className='px-[10px] mt-2 w-full ' id="adsSection">
                                                        <div className={`relative mt-2 grid  sm:grid-cols-1 md:grid-cols-2  gap-[10px] sm:gap-[0px] 
                                                            ${props.userCode ? "grid-cols-2 lg:grid-cols-1 md:grid-cols-1 xl:grid-cols-2 " : "grid-cols-4 lg:grid-cols-3 xl:grid-cols-3  md:grid-cols-2 "} `}
                                                            onClick={() => addItemsInStore(items, page)}>
                                                            {/* {
                                                                items.filter(item => item.adsAdvertiseTypeCode == 2).map(item => (
                                                                    <OneCard key={item.id} item={item}
                                                                    />
                                                                ))
                                                            } */}
                                                        </div>
                                                    </div>
                                                    <div className='px-[10px] mt-4 sm:mt-1 ' id="AdsWrapper">
                                                        <div className={`relative mt-2 grid   sm:grid-cols-1 md:grid-cols-2  gap-[10px] sm:gap-[0px] 
                                                            ${props.userCode ? "grid-cols-2 lg:grid-cols-1 md:grid-cols-1 xl:grid-cols-2 " : "grid-cols-4 lg:grid-cols-3 xl:grid-cols-3  md:grid-cols-2"} `}
                                                            onClick={() => addItemsInStore(items, page)}>
                                                            {noResult ? <p></p> :
                                                                items.map(item => {
                                                                    return (
                                                                        isProfilePage ? <div className="relative">
                                                                            <div className={`absolute  flex items-center px-3 text-[12px] rounded-lg  ${item?.registerStatusCode === 23 ? `bg-green-300 font-bold` : `text-blue-950 bg-white dark:!text-blue-200`}`}>{registerStatus[item?.registerStatusCode]}</div>
                                                                            <TwoCard key={item.id} item={item} />
                                                                        </div> : <TwoCard key={item.id} item={item} />


                                                                    )
                                                                })
                                                            }



                                                        </div>

                                                        {noResult && <div className="">
                                                            {isProfilePage ? <div className='flex items-center justify-center flex-col w-full '>
                                                                <p className='font-bold text-center'> شما هنوز آگهی ای ثبت نکرده اید</p>
                                                                <button onClick={async () => {
                                                                    // await props.setIsSearch(false)
                                                                    // props?.setSearchValue("")
                                                                    localStorage.setItem("locationNameVeeu", JSON.stringify({ id: 3, locName: "تهران" }))
                                                                    showAllAdss()
                                                                    navigate(`/RegisterAD`)
                                                                }
                                                                } className='bg-main px-8 py-1 text-white rounded mb-12'>   ثبت آگهی</button>
                                                            </div> :
                                                                <div className='flex items-center justify-center flex-col w-full '>
                                                                    <p className='font-bold text-center'>  22222 آگهی با  مشخصات مورد نظر یافت نشد</p>

                                                                    {!isInTehranCity ? <p className="mt-4">لطفا شهر یا استان را تغییر دهید</p> :
                                                                        <button onClick={async () => {
                                                                            await setSearchValue("")
                                                                            // await props.setIsSearch(false)
                                                                            // props.setSearchValue("")
                                                                            // localStorage.setItem("locationNameVeeu", JSON.stringify({ id: 3, locName: "تهران" }))
                                                                            showAllAdss()
                                                                        }
                                                                        } className='bg-main px-8 py-1 text-white rounded mb-12'> نمایش همه آگهی ها
                                                                        </button>
                                                                    }




                                                                </div>}

                                                        </div>
                                                        }

                                                    </div>

                                                </InfiniteScroll>
                                            </div>
                                        ) : (
                                            <>
                                                {loader ? (<Loader isLoaderTop={true} />) : (<div className='px-1 mb-24 '>

                                                    <div className={`relative grid gap-2  grid-cols-4 lg:grid-cols-2 xl:grid-cols-3  md:grid-cols-2 sm:grid-cols-1 kelas `}>
                                                        <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={fetchData}
                                                            hasMore={hasMore}
                                                            loader={
                                                                <div className="w-full flex items-center justify-center gap-2 font-bold text-center my-4" key={0}>
                                                                    <p>  درحال بارگذاری</p>
                                                                    <div class="loading">
                                                                        <span class="loading__dot"></span>
                                                                        <span class="loading__dot"></span>
                                                                        <span class="loading__dot"></span>
                                                                    </div>
                                                                </div>
                                                            }
                                                        >
                                                            {
                                                                items.length ?
                                                                    //  allMasterOrders.filter(item => item.adsAdvertiseTypeCode !== 2).map(item => (
                                                                    items.map(item => (
                                                                        // item.adsAdvertiseShowTypeCode == 2 ? (
                                                                        //     <OneCard key={item.id} item={item} isSearch={isSearch} />
                                                                        // ) : (

                                                                        <TwoCard key={item.id} item={item} isSearch={props.isSearch} />

                                                                        // )
                                                                    )) : (
                                                                        // <div className='flex items-center justify-center flex-col w-full absolute '>
                                                                        //     <p className='font-bold text-center'>آگهی با مشخصات مورد نظر یافت نشد 3 3</p>
                                                                        //     <button onClick={async () => {
                                                                        //         await props.setIsSearch(false)
                                                                        //         props.setSearchValue("")
                                                                        //         localStorage.setItem("locationNameVeeu", JSON.stringify({ id: 3, locName: "تهران" }))
                                                                        //         showAllAdss()
                                                                        //     }
                                                                        //     } className='bg-main px-8 py-1 text-white rounded mb-12'>نمایش همه آگهی ها</button>
                                                                        // </div>
                                                                        <></>
                                                                    )
                                                            }
                                                        </InfiniteScroll>
                                                    </div>
                                                </div>)}

                                            </>
                                        )
                                    }
                                </>
                            )
                        )

                )
            }


        </>
    )
}


export default NewFilter